import {
    patient_investigate_rx,
    investigate_rx_metrics,
    investigate_rx_metrics_details,
    sync_investigateRX,
    patient_rxview_prescription,
    // patient_rxview_prescription_sync,
    get_winrx_mapping_data,
    update_common_sig_prescription,
    pharmacy_rx_prescriptions_pdf,
    pharmacy_investigate_getinvestigateTemplate,
    pharmacy_save_pdf_template_data,
    pharmacy_save_multiple_pdf_template_data,
    pharmacy_preview_winrx_emergency_template_pdf,
    pharmacy_submit_winrx_emergency_template_pdf,
    update_login_pharmacist_cpsid,
    pharmacy_rx_signature_requestlog,
    check_bridge_connection,
    update_frequency_qty,
    update_iv_code,
    update_dose_code,
    patient_rx_history,
    patient_rx_view_documents,
    save_ai_dates,
    update_prescription_quantity,
    get_rx_stock,
    get_pharmacy_rx_day_wise_doses,
    accountability_singleDispenseRxStatusUpdate,
    accountability_isScCarryDoseUpdate,
    sync_rx,
    map_drug_rx_number,
    get_patient_document_list,
    check_rxnumber_dilaudid,
    accountability_markRefillFlexi,
    update_do_not_bill,
    med_rephrase_drp,
    pharmacy_investigate_getinvestigateTemplate_for_bulk,
    pharmacy_ai_chat,
    update_front_sig_check,
    pharmacy_rx_deleted_status,
    investigation_ai_setting,
    investigate_din_group_drugs,
    investigate_din_change_notice,
    // get_last_seven_rdelivery,
    save_schedule_dose
} from '../../../../networking/urlEndPoints';

import {
    calculateDaysSupply,
    handleGetChangingDoseData
} from '../../../../utils/helper/investigationRx';

import {
    canAiSetChangingDose,
    hasSavedFrequencyRows,
    normalizeAiChangingSchedule,
    shouldAutoSaveAiChangingSchedule
} from '../../../../utils/helper/aiChangingDoseSchedule';
import { safeToast } from '../../../../utils/helper/helper';
import Axios from '../../../../networking/intraceptor';
import axios from 'axios';
import { showToast } from '../../../../utils/helper/helper';
// Action Types
const PHARMACY_INVESTIGATE_RX_REQUEST = 'PHARMACY_INVESTIGATE_RX_REQUEST';
const PHARMACY_INVESTIGATE_RX_SUCCESS = 'PHARMACY_INVESTIGATE_RX_SUCCESS';
const PHARMACY_INVESTIGATE_RX_FAILURE = 'PHARMACY_INVESTIGATE_RX_FAILURE';

const INVESTIGATE_RX_METRICS_REQUEST = 'INVESTIGATE_RX_METRICS_REQUEST';
const INVESTIGATE_RX_METRICS_SUCCESS = 'INVESTIGATE_RX_METRICS_SUCCESS';
const INVESTIGATE_RX_METRICS_FAILURE = 'INVESTIGATE_RX_METRICS_FAILURE';

const INVESTIGATE_RX_METRIC_DETAILS_REQUEST = 'INVESTIGATE_RX_METRIC_DETAILS_REQUEST';
const INVESTIGATE_RX_METRIC_DETAILS_SUCCESS = 'INVESTIGATE_RX_METRIC_DETAILS_SUCCESS';
const INVESTIGATE_RX_METRIC_DETAILS_FAILURE = 'INVESTIGATE_RX_METRIC_DETAILS_FAILURE';

const INVESTIGATE_SYNC_RX_REQUEST = 'INVESTIGATE_SYNC_RX_REQUEST';
const INVESTIGATE_SYNC_RX_SUCCESS = 'INVESTIGATE_SYNC_RX_SUCCESS';
const INVESTIGATE_SYNC_RX_FAILURE = 'INVESTIGATE_SYNC_RX_FAILURE';

const PATIENT_REVIEW_PRESCRIPTION_DETAILS_REQUEST = 'PATIENT_REVIEW_PRESCRIPTION_DETAILS_REQUEST';
const PATIENT_REVIEW_PRESCRIPTION_DETAILS_SUCCESS = 'PATIENT_REVIEW_PRESCRIPTION_DETAILS_SUCCESS';
const PATIENT_REVIEW_PRESCRIPTION_DETAILS_FAILURE = 'PATIENT_REVIEW_PRESCRIPTION_DETAILS_FAILURE';

const DR_SIGNATURE_VERIFIED_DATA = 'DR_SIGNATURE_VERIFIED_DATA';
const CLEAR_INVESTIGATE_RX_DATA = 'CLEAR_INVESTIGATE_RX_DATA';
const INVESTIGATE_RX_PDF_CURRENT_PAGE = 'INVESTIGATE_RX_PDF_CURRENT_PAGE';

const RX_PRESCRIPTION_PDF_REQUEST = 'RX_PRESCRIPTION_PDF_REQUEST';
const RX_PRESCRIPTION_PDF_SUCCESS = 'RX_PRESCRIPTION_PDF_SUCCESS';
const RX_PRESCRIPTION_PDF_FAILURE = 'RX_PRESCRIPTION_PDF_FAILURE';

const RX_SIGNATURES_REQUESTED_LIST_REQUEST = 'RX_SIGNATURES_REQUESTED_LIST_REQUEST';
const RX_SIGNATURES_REQUESTED_LIST_SUCCESS = 'RX_SIGNATURES_REQUESTED_LIST_SUCCESS';
const RX_SIGNATURES_REQUESTED_LIST_FAILURE = 'RX_SIGNATURES_REQUESTED_LIST_FAILURE';

const CHECK_BRIDGE_CONNECTION_REQUEST = 'CHECK_BRIDGE_CONNECTION_REQUEST';
const CHECK_BRIDGE_CONNECTION_SUCCESS = 'CHECK_BRIDGE_CONNECTION_SUCCESS';
const CHECK_BRIDGE_CONNECTION_FAILURE = 'CHECK_BRIDGE_CONNECTION_FAILURE';

const UPDATE_FREQUENCY_QTY_REQUEST = 'UPDATE_FREQUENCY_QTY_REQUEST';
const UPDATE_FREQUENCY_QTY_SUCCESS = 'UPDATE_FREQUENCY_QTY_SUCCESS';
const UPDATE_FREQUENCY_QTY_FAILURE = 'UPDATE_FREQUENCY_QTY_FAILURE';

const PATIENT_RX_HISTORY_REQUEST = 'PATIENT_RX_HISTORY_REQUEST';
const PATIENT_RX_HISTORY_SUCCESS = 'PATIENT_RX_HISTORY_SUCCESS';
const PATIENT_RX_HISTORY_FAILURE = 'PATIENT_RX_HISTORY_FAILURE';

const PATIENT_RX_VIEW_DOCUMENTS_REQUEST = 'PATIENT_RX_VIEW_DOCUMENTS_REQUEST';
const PATIENT_RX_VIEW_DOCUMENTS_SUCCESS = 'PATIENT_RX_VIEW_DOCUMENTS_SUCCESS';
const PATIENT_RX_VIEW_DOCUMENTS_FAILURE = 'PATIENT_RX_VIEW_DOCUMENTS_FAILURE';

const SIG_AI_REQUEST = 'SIG_AI_REQUEST';
const SIG_AI_SUCCESS = 'SIG_AI_SUCCESS';
const SIG_AI_FAILURE = 'SIG_AI_FAILURE';

const UPDATE_AIDATES_REQUEST = 'UPDATE_AIDATES_REQUEST';
const UPDATE_AIDATES_SUCCESS = 'UPDATE_AIDATES_SUCCESS';
const UPDATE_AIDATES_FAILURE = 'UPDATE_AIDATES_FAILURE';

const PHARMACY_GET_RX_STOCK_REQUEST = 'PHARMACY_GET_RX_STOCK_REQUEST';
const PHARMACY_GET_RX_STOCK_SUCCESS = 'PHARMACY_GET_RX_STOCK_SUCCESS';
const PHARMACY_GET_RX_STOCK_FAILURE = 'PHARMACY_GET_RX_STOCK_FAILURE';

const PHARMACY_RX_DELETED_STATUS_REQUEST = 'PHARMACY_RX_DELETED_STATUS_REQUEST';
const PHARMACY_RX_DELETED_STATUS_SUCCESS = 'PHARMACY_RX_DELETED_STATUS_SUCCESS';
const PHARMACY_RX_DELETED_STATUS_FAILURE = 'PHARMACY_RX_DELETED_STATUS_FAILURE';

const RX_DAY_WISE_DOSES_REQUEST = 'RX_DAY_WISE_DOSES_REQUEST';
const RX_DAY_WISE_DOSES_SUCCESS = 'RX_DAY_WISE_DOSES_SUCCESS';
const RX_DAY_WISE_DOSES_FAILURE = 'RX_DAY_WISE_DOSES_FAILURE';

const SYNC_RX_REQUEST = 'SYNC_RX_REQUEST';
const SYNC_RX_SUCCESS = 'SYNC_RX_SUCCESS';
const SYNC_RX_FAILURE = 'SYNC_RX_FAILURE';

const MAP_DRUG_RX_NUMBER_REQUEST = 'MAP_DRUG_RX_NUMBER_REQUEST';
const MAP_DRUG_RX_NUMBER_SUCCESS = 'MAP_DRUG_RX_NUMBER_SUCCESS';
const MAP_DRUG_RX_NUMBER_FAILURE = 'MAP_DRUG_RX_NUMBER_FAILURE';

const GET_PATIENT_DOCUMENT_LIST_REQUEST = 'GET_PATIENT_DOCUMENT_LIST_REQUEST';
const GET_PATIENT_DOCUMENT_LIST_SUCCESS = 'GET_PATIENT_DOCUMENT_LIST_SUCCESS';
const GET_PATIENT_DOCUMENT_LIST_FAILURE = 'GET_PATIENT_DOCUMENT_LIST_FAILURE';

const CHECK_RXNUMBER_DILAUDID_REQUEST = 'CHECK_RXNUMBER_DILAUDID_REQUEST';
const CHECK_RXNUMBER_DILAUDID_SUCCESS = 'CHECK_RXNUMBER_DILAUDID_SUCCESS';
const CHECK_RXNUMBER_DILAUDID_FAILURE = 'CHECK_RXNUMBER_DILAUDID_FAILURE';

const MARK_REFILL_FLEXI_REQUEST = 'MARK_REFILL_FLEXI_REQUEST';
const MARK_REFILL_FLEXI_SUCCESS = 'MARK_REFILL_FLEXI_SUCCESS';
const MARK_REFILL_FLEXI_FAILURE = 'MARK_REFILL_FLEXI_FAILURE';

const UPDATE_REPHRASE_NOTES_REQUEST = 'UPDATE_REPHRASE_NOTES_REQUEST';
const UPDATE_REPHRASE_NOTES_SUCCESS = 'UPDATE_REPHRASE_NOTES_SUCCESS';
const UPDATE_REPHRASE_NOTES_FAILURE = 'UPDATE_REPHRASE_NOTES_FAILURE';

const UPDATE_MULTIPLE_PDF_TEMPLATE_REQUEST = 'UPDATE_MULTIPLE_PDF_TEMPLATE_REQUEST';
const UPDATE_MULTIPLE_PDF_TEMPLATE_SUCCESS = 'UPDATE_MULTIPLE_PDF_TEMPLATE_SUCCESS';
const UPDATE_MULTIPLE_PDF_TEMPLATE_FAILURE = 'UPDATE_MULTIPLE_PDF_TEMPLATE_FAILURE';
const UPDATE_PRESCRIPTION_QUANTITY_LOCAL = 'UPDATE_PRESCRIPTION_QUANTITY_LOCAL';
const UPDATE_PRESCRIPTION_FREQUENCY_LOCAL = 'UPDATE_PRESCRIPTION_FREQUENCY_LOCAL';
const MARK_PRESCRIPTION_AI_CHANGING_LOCAL = 'MARK_PRESCRIPTION_AI_CHANGING_LOCAL';
const UPDATE_RX_STOP_DATE_LOCAL = 'UPDATE_RX_STOP_DATE_LOCAL';
const UPDATE_RX_WRITTEN_DATE_LOCAL = 'UPDATE_RX_WRITTEN_DATE_LOCAL';

const READ_SIG_REQUEST = 'READ_SIG_REQUEST';
const READ_SIG_SUCCESS = 'READ_SIG_SUCCESS';
const READ_SIG_FAILURE = 'READ_SIG_FAILURE';

const LAST_SEVEN_RDELIVERY_REQUEST = 'LAST_SEVEN_RDELIVERY_REQUEST';
const LAST_SEVEN_RDELIVERY_SUCCESS = 'LAST_SEVEN_RDELIVERY_SUCCESS';
const LAST_SEVEN_RDELIVERY_FAILURE = 'LAST_SEVEN_RDELIVERY_FAILURE';

const POST_WITNESS_CARRY_CYCLE_REQUEST = 'POST_WITNESS_CARRY_CYCLE_REQUEST';
const POST_WITNESS_CARRY_CYCLE_SUCCESS = 'POST_WITNESS_CARRY_CYCLE_SUCCESS';
const POST_WITNESS_CARRY_CYCLE_FAILURE = 'POST_WITNESS_CARRY_CYCLE_FAILURE';

const DELETE_WITNESS_CARRY_CYCLE_REQUEST = 'DELETE_WITNESS_CARRY_CYCLE_REQUEST';
const DELETE_WITNESS_CARRY_CYCLE_SUCCESS = 'DELETE_WITNESS_CARRY_CYCLE_SUCCESS';
const DELETE_WITNESS_CARRY_CYCLE_FAILURE = 'DELETE_WITNESS_CARRY_CYCLE_FAILURE';

const GET_WINRX_MAPPING_DATA_REQUEST = 'GET_WINRX_MAPPING_DATA_REQUEST';
const GET_WINRX_MAPPING_DATA_SUCCESS = 'GET_WINRX_MAPPING_DATA_SUCCESS';
const GET_WINRX_MAPPING_DATA_FAILURE = 'GET_WINRX_MAPPING_DATA_FAILURE';

const INVESTIGATION_AI_SETTING_REQUEST = 'INVESTIGATION_AI_SETTING_REQUEST';
const INVESTIGATION_AI_SETTING_SUCCESS = 'INVESTIGATION_AI_SETTING_SUCCESS';
const INVESTIGATION_AI_SETTING_FAILURE = 'INVESTIGATION_AI_SETTING_FAILURE';

// Action Creators

//Fetch All Today's Investigation List
export const clearInvestigateRxData = () => ({
    type: CLEAR_INVESTIGATE_RX_DATA,
});

export const requestInvestigateRx = (requestType) => ({
    type: PHARMACY_INVESTIGATE_RX_REQUEST,
    payload: { requestType },
});

export const successInvestigateRx = (data, requestType) => ({
    type: PHARMACY_INVESTIGATE_RX_SUCCESS,
    payload: { data, requestType },
});

export const failureInvestigateRx = (error, requestType) => ({
    type: PHARMACY_INVESTIGATE_RX_FAILURE,
    payload: { error, requestType },
});

export const fetchPatientInvestigateRxList = ({ formData, requestType, page = 1, sortBy, order }) => {
    return async (dispatch) => {
        dispatch(requestInvestigateRx(requestType));

        try {
            const { date, endDate, search, patientRoutes, viewed, status, emergency_type, scan_status, narcotic_type } = formData

            const params = {
                search_date: date,
                search_date_to: endDate,
                page,
            };

            if (search) params.search = search
            if (patientRoutes?.label) params.route = patientRoutes?.label
            if (viewed) params.listtype = viewed
            if (status) params.status = status
            if (sortBy) params.sortby = sortBy
            if (order) params.order = order

            if (emergency_type) params.emergency_type = emergency_type
            if (scan_status) params.scan_status = scan_status
            if (narcotic_type) params.narcotic_type = narcotic_type

            const response = await Axios.get(patient_investigate_rx, { params });

            if (response.status === 200) {
                dispatch(successInvestigateRx(response.data, requestType));
            } else {
                throw new Error('Unexpected response status');
            }

        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'An error occurred';
            dispatch(failureInvestigateRx(errorMessage, requestType));
        }
    };
};
//Fetch All Today's Investigation List End

//Investigation Analytics tiles
export const requestInvestigateRxMetrics = (requestType) => ({
    type: INVESTIGATE_RX_METRICS_REQUEST,
    payload: { requestType },
});

export const successInvestigateRxMetrics = (data, requestType) => ({
    type: INVESTIGATE_RX_METRICS_SUCCESS,
    payload: { data, requestType },
});

export const failureInvestigateRxMetrics = (error, requestType) => ({
    type: INVESTIGATE_RX_METRICS_FAILURE,
    payload: { error, requestType },
});

/**
 * Total RX / Pending / Completed / Completion % for a DATE RANGE.
 *
 * Same scope as the Investigation list above - deliberately the same param names
 * (route, status) so the two screens can never be asking different questions.
 */
export const fetchInvestigateRxMetrics = ({ from, to, route, status, requestType }) => {
    return async (dispatch) => {
        dispatch(requestInvestigateRxMetrics(requestType));

        try {
            const params = {};

            if (from) params.from = from
            if (to) params.to = to
            if (route) params.route = route
            if (status) params.status = status

            const response = await Axios.get(investigate_rx_metrics, { params });

            if (response.status === 200) {
                dispatch(successInvestigateRxMetrics(response.data, requestType));
            } else {
                throw new Error('Unexpected response status');
            }

        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'An error occurred';
            dispatch(failureInvestigateRxMetrics(errorMessage, requestType));
        }
    };
};

//Investigation Analytics details table
export const requestInvestigateRxMetricDetails = (requestType) => ({
    type: INVESTIGATE_RX_METRIC_DETAILS_REQUEST,
    payload: { requestType },
});

export const successInvestigateRxMetricDetails = (data, requestType) => ({
    type: INVESTIGATE_RX_METRIC_DETAILS_SUCCESS,
    payload: { data, requestType },
});

export const failureInvestigateRxMetricDetails = (error, requestType) => ({
    type: INVESTIGATE_RX_METRIC_DETAILS_FAILURE,
    payload: { error, requestType },
});

/**
 * The rows behind the tiles - "which RX are pending and which are completed".
 *
 * Takes the SAME from/to/route/status the tiles take, because the API resolves both through
 * one scope: whatever this returns is exactly what the numbers above it counted. `rowStatus`
 * ('all' | 'pending' | 'completed') only picks which side of the split to show.
 */
export const fetchInvestigateRxMetricDetails = ({ from, to, route, status, rowStatus, page, perPage, requestType }) => {
    return async (dispatch) => {
        dispatch(requestInvestigateRxMetricDetails(requestType));

        try {
            const params = {};

            if (from) params.from = from
            if (to) params.to = to
            if (route) params.route = route
            if (status) params.status = status
            if (rowStatus && rowStatus !== 'all') params.row_status = rowStatus
            if (page) params.page = page
            if (perPage) params.per_page = perPage

            const response = await Axios.get(investigate_rx_metrics_details, { params });

            if (response.status === 200) {
                dispatch(successInvestigateRxMetricDetails(response.data, requestType));
            } else {
                throw new Error('Unexpected response status');
            }

        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'An error occurred';
            dispatch(failureInvestigateRxMetricDetails(errorMessage, requestType));
        }
    };
};
//Investigation Analytics tiles End

//SYNC RX
export const requestSyncRx = (requestType) => ({
    type: INVESTIGATE_SYNC_RX_REQUEST,
    payload: { requestType },
});

export const successSyncRx = (data, requestType) => ({
    type: INVESTIGATE_SYNC_RX_SUCCESS,
    payload: { data, requestType },
});

export const failureSyncRx = (error, requestType) => ({
    type: INVESTIGATE_SYNC_RX_FAILURE,
    payload: { error, requestType },
});

export const UpdateDRSign = (data, requestType) => ({
    type: DR_SIGNATURE_VERIFIED_DATA,
    payload: { data, requestType },
});

export const updatePrescriptionQuantityLocal = (quantity) => ({
    type: UPDATE_PRESCRIPTION_QUANTITY_LOCAL,
    payload: { quantity },
});

export const updateRxStopDateLocal = (payload) => ({
    type: UPDATE_RX_STOP_DATE_LOCAL,
    payload,
});

export const updateRxWrittenDateLocal = (payload) => ({
    type: UPDATE_RX_WRITTEN_DATE_LOCAL,
    payload,
});

// Every day from start to end, inclusive. The sync endpoint pulls one WinRx day per call.
export const listRangeDays = (startDate, endDate) => {
    const days = [];
    const lastDay = new Date(`${endDate || startDate}T00:00:00Z`);

    for (let day = new Date(`${startDate}T00:00:00Z`); day <= lastDay; day.setUTCDate(day.getUTCDate() + 1)) {
        days.push(day.toISOString().split('T')[0]);
    }

    return days;
};

export const SyncInvestigateRx = ({ formData, fetchType }) => {
    return async (dispatch) => {
        dispatch(requestSyncRx(fetchType));

        try {
            let response;
            for (const date of listRangeDays(formData?.date, formData?.endDate)) {
                response = await Axios.post(sync_investigateRX, { date });
            }

            if (response.status === 200) {
                safeToast.success(`RX data synced successfully`);

                dispatch(clearInvestigateRxData());
                dispatch(successSyncRx(response.data, fetchType));
                dispatch(fetchPatientInvestigateRxList({ formData, requestType: 'investigate_rx' }))
                return true
            } else {
                throw new Error('Unexpected response status');
            }
        } catch (error) {
            safeToast.error('Failed to sync RX data. Please try again.');
            const errorMessage = error?.response?.data || 'An error occurred';
            dispatch(failureSyncRx(errorMessage, fetchType));
            return false
        }
    };
};
//SYNC RX


//Get patient prescription on basis of Rx number
export const patientPrescriptionRequest = (requestType) => ({
    type: PATIENT_REVIEW_PRESCRIPTION_DETAILS_REQUEST,
    payload: { requestType },
});

export const patientPrescriptionSuccess = (data, requestType) => ({
    type: PATIENT_REVIEW_PRESCRIPTION_DETAILS_SUCCESS,
    payload: { data, requestType },
});

export const patientPrescriptionFailure = (error, requestType) => ({
    type: PATIENT_REVIEW_PRESCRIPTION_DETAILS_FAILURE,
    payload: { error, requestType },
});

// Frequency rows saved for the open Rx (e.g. by the AI SIG check), so the page
// reads them the same way it would after a refresh.
export const updatePrescriptionFrequencyLocal = (rxesId, frequencyData) => ({
    type: UPDATE_PRESCRIPTION_FREQUENCY_LOCAL,
    payload: { rxesId, frequencyData },
});

// The AI read the open Rx as a changing dose but its steps were not saved:
// the page goes to Changing with the doses left for the pharmacist to enter.
export const markPrescriptionAiChangingLocal = (rxesId) => ({
    type: MARK_PRESCRIPTION_AI_CHANGING_LOCAL,
    payload: { rxesId },
});

// WinRx Mapping Data Actions
export const winrxMappingDataRequest = (requestType) => ({
    type: GET_WINRX_MAPPING_DATA_REQUEST,
    payload: { requestType },
});

export const winrxMappingDataSuccess = (data, requestType) => ({
    type: GET_WINRX_MAPPING_DATA_SUCCESS,
    payload: { data, requestType },
});

export const winrxMappingDataFailure = (error, requestType) => ({
    type: GET_WINRX_MAPPING_DATA_FAILURE,
    payload: { error, requestType },
});

export const investigationAiSettingRequest = (requestType) => ({
    type: INVESTIGATION_AI_SETTING_REQUEST,
    payload: { requestType },
});

export const investigationAiSettingSuccess = (data, requestType) => ({
    type: INVESTIGATION_AI_SETTING_SUCCESS,
    payload: { data, requestType },
});

export const investigationAiSettingFailure = (error, requestType) => ({
    type: INVESTIGATION_AI_SETTING_FAILURE,
    payload: { error, requestType },
});

export const fetchInvestigationAiSetting = ({ requestType = 'investigation_ai_setting' } = {}) => {
    return async (dispatch) => {
        dispatch(investigationAiSettingRequest(requestType));

        try {
            const response = await Axios.get(investigation_ai_setting);

            if (response.status === 200) {
                dispatch(investigationAiSettingSuccess(response.data, requestType));
            } else {
                throw new Error('Unexpected response status');
            }
        } catch (error) {
            const errorMessage = error?.response?.data || error?.message || 'An error occurred';
            dispatch(investigationAiSettingFailure(errorMessage, requestType));
        }
    };
};

export const fetchPatientPriscriptionDetails = ({ rxnumber,
    fetchType,
    recordAudit = true,
    skippedRx,
    setIsChanging,
    setFrequencyRows,
    setFrequency,
    setDoseInputs,
    setHasChangingDoseData,
    setChangingUpdateType,
    setSelectedDaysArray,
    setSelectedFQY
}) => {
    return async (dispatch, getState) => {
        dispatch(patientPrescriptionRequest(fetchType));
        dispatch(winrxMappingDataSuccess(null, 'winrx_mapping_data'));
        try {
            let updatedRxNumbers = [];
            if (rxnumber) {
                const rxNumbers = JSON.parse(sessionStorage.getItem('updatedRxNumbers')) || [];
                if (!rxNumbers.includes(rxnumber)) {
                    updatedRxNumbers = [rxnumber, ...rxNumbers]
                    sessionStorage.setItem('updatedRxNumbers', JSON.stringify(updatedRxNumbers))
                } else {
                    updatedRxNumbers = [...rxNumbers]
                    sessionStorage.setItem('updatedRxNumbers', JSON.stringify(updatedRxNumbers))
                }
            }
            const params = {
                rxnumber: rxnumber,
                audit_open: recordAudit ? 1 : 0,
            };
            if (skippedRx) {
                params.skippedrx = skippedRx
            }

            const response = await Axios.get(patient_rxview_prescription, { params });
            if (response.status === 200) {
                dispatch(patientPrescriptionSuccess(response.data, fetchType));

                // Investigation page reads AI mapping availability from its own API.
                let aiMappingEnabled = false;

                try {
                    const aiSettingResponse = await Axios.get(investigation_ai_setting);

                    if (aiSettingResponse.status === 200) {
                        dispatch(investigationAiSettingSuccess(aiSettingResponse.data, 'investigation_ai_setting'));
                        const aiSettingData = aiSettingResponse?.data?.data;
                        aiMappingEnabled = aiSettingData?.ai_mapping_enabled === true
                            || aiSettingData?.ai_mapping_enabled === 1
                            || aiSettingData?.ai_mapping_enabled === '1';
                    }
                } catch (settingError) {
                    dispatch(investigationAiSettingFailure(settingError?.response?.data || settingError?.message, 'investigation_ai_setting'));
                }

                if (aiMappingEnabled) {
                    try {
                        dispatch(winrxMappingDataRequest('winrx_mapping_data'));
                        const winrxResponse = await Axios.get(get_winrx_mapping_data, {
                            params: { rx_number: rxnumber }
                        });
                        // Store response for both success true (verification) and success false (show AI button when mapping not found)
                        if (winrxResponse?.data != null) {
                            dispatch(winrxMappingDataSuccess(winrxResponse.data, 'winrx_mapping_data'));
                        }
                    } catch (getError) {
                        // 404 with body { success: false, ... } means "mapping not found" - store it so AI button can show
                        const errResponse = getError?.response;
                        if (errResponse?.status === 404 && errResponse?.data?.success === false) {
                            dispatch(winrxMappingDataSuccess(errResponse.data, 'winrx_mapping_data'));
                        } else if (errResponse?.status !== 200) {
                            dispatch(winrxMappingDataFailure(errResponse?.data || getError.message, 'winrx_mapping_data'));
                        }
                    }
                }


                const changingDose = response?.data?.data?.is_ai_changing_dose === 1 ? true : false;
                const hasChangingDoseData = response?.data?.data?.get_requency_data?.is_changing ? true : false;

                // get_requency_data always carries delivery_gap, so it is never an
                // empty object: look for the dose rows themselves. Testing only
                // "is it an object" meant the AI check below stopped running.
                const hasSavedRows = hasSavedFrequencyRows(response?.data?.data?.get_requency_data);
                // Nothing a pharmacist entered is saved (no rows, or only the
                // system's own flat daily row), so the AI still gets to read the
                // SIG: that flat row must not hide a changing dose.
                const hasValidFrequencyData = hasSavedRows && !canAiSetChangingDose(response?.data?.data);

                if (changingDose && !hasChangingDoseData && !hasValidFrequencyData) {
                    dispatch({
                        type: SIG_AI_SUCCESS,
                        payload: {
                            data: {
                                changingDose: changingDose,
                            }, // Only dispatch the boolean
                            requestType: 'sig_ai'
                        }
                    });
                }

                if (response?.data?.data?.is_front_sig_check === 1) return
                if (!hasValidFrequencyData) {
                    const sig = response?.data?.data?.prescription_detail?.sig;
                    // Check if this rxnumber has already been processed
                    const processedRxNumbers = JSON.parse(sessionStorage.getItem('processedRxNumbers')) || [];
                    const isAlreadyProcessed = processedRxNumbers.includes(rxnumber);

                    // if (!isAlreadyProcessed && sig) {
                    if (!isAlreadyProcessed && sig && process.env.NODE_ENV === 'production') {
                        // Add this rxnumber to processed list
                        processedRxNumbers.push(rxnumber);
                        sessionStorage.setItem('processedRxNumbers', JSON.stringify(processedRxNumbers));
                        dispatch(checkSIGforChangingDose({
                            sigDetails: sig,
                            requestType: 'sig_ai',
                            patientDetails: response?.data?.data,
                            setIsChanging,
                            setFrequencyRows,
                            setFrequency,
                            setDoseInputs,
                            setHasChangingDoseData,
                            setChangingUpdateType,
                            setSelectedDaysArray,
                            setSelectedFQY
                        }));

                        // const payload = {
                        //     rxes_id: response?.data?.data?.rxdata_id,
                        //     is_front_sig_check: 1
                        // }

                        // processSIGWithAI(payload)
                    }
                }

            } else {
                throw new Error('Unexpected response status');
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            dispatch(patientPrescriptionFailure(errorMessage, fetchType));
        }
    };
};


const processSIGWithAI = async (payload) => {
    try {
        const response = await Axios.post(`${update_front_sig_check}`, payload);
        return response; // fallback if no key in response
    } catch (error) {
        return error// fallback to environment variable
    }
}
//Get patient prescription on basis of Rx number End

//Get Patient Investigation PDF on basis of rx
export const investigationRX_PDF_Request = (requestType, preserveExistingData = false) => ({
    type: RX_PRESCRIPTION_PDF_REQUEST,
    payload: { requestType, preserveExistingData },
});

export const investigationRX_PDF_Success = (data, requestType, preserveExistingData = false) => ({
    type: RX_PRESCRIPTION_PDF_SUCCESS,
    payload: { data, requestType, preserveExistingData },
});

export const investigationRX_PDF_Failure = (error, requestType) => ({
    type: RX_PRESCRIPTION_PDF_FAILURE,
    payload: { error, requestType },
});

export const investigateCurrentPage = (data, requestType) => ({
    type: INVESTIGATE_RX_PDF_CURRENT_PAGE,
    payload: { data, requestType },
});

export const fetchPatientInvestigationRxPDF = ({ rx, requestType, templateData, preserveExistingData = false }) => {
    return async (dispatch) => {
        dispatch(investigationRX_PDF_Request(requestType, preserveExistingData));

        try {
            const params = {
                rxnumber: rx
            }

            if (templateData) {
                params.templateData = templateData
            }

            const response = await Axios.get(pharmacy_rx_prescriptions_pdf, { params });

            if (response.status === 200) {
                dispatch(investigationRX_PDF_Success(response.data, requestType, preserveExistingData));
            } else {
                throw new Error('Unexpected response status');
            }

        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            dispatch(investigationRX_PDF_Failure(errorMessage, requestType));
        }
    };
};
//Get Patient Investigation PDF on basis of rx End

//View Documents PDF
export const patientRxViewDocumentsRequest = (requestType) => ({
    type: PATIENT_RX_VIEW_DOCUMENTS_REQUEST,
    payload: { requestType },
});

export const patientRxViewDocumentsSuccess = (data, requestType) => ({
    type: PATIENT_RX_VIEW_DOCUMENTS_SUCCESS,
    payload: { data, requestType },
});

export const patientRxViewDocumentsFailure = (error, requestType) => ({
    type: PATIENT_RX_VIEW_DOCUMENTS_FAILURE,
    payload: { error, requestType },
});

export const fetchPatientRxViewDocuments = ({ params, requestType }) => {
    return async (dispatch) => {
        dispatch(patientRxViewDocumentsRequest(requestType));
        try {
            const response = await Axios.post(patient_rx_view_documents, params);
            if (response.status === 200) {
                dispatch(patientRxViewDocumentsSuccess(response.data, requestType));
            } else {
                throw new Error('Unexpected response status');
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            dispatch(patientRxViewDocumentsFailure(errorMessage, requestType));
        }
    };
};
//View Documents PDF End

//Rx Signatures Request
export const investigationRxRequestedListRequest = (requestType) => ({
    type: RX_SIGNATURES_REQUESTED_LIST_REQUEST,
    payload: { requestType },
});

export const investigationRxRequestedListSuccess = (data, requestType) => ({
    type: RX_SIGNATURES_REQUESTED_LIST_SUCCESS,
    payload: { data, requestType },
});

export const investigationRxRequestedListFailure = (error, requestType) => ({
    type: RX_SIGNATURES_REQUESTED_LIST_FAILURE,
    payload: { error, requestType },
});

export const fetchRxSignatuesRequestedList = ({ requestType, params }) => {
    return async (dispatch) => {
        dispatch(investigationRxRequestedListRequest(requestType));
        try {
            const response = await Axios.get(pharmacy_rx_signature_requestlog, { params })
            if (response.status === 200) {
                dispatch(investigationRxRequestedListSuccess(response.data, requestType));
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            dispatch(investigationRxRequestedListFailure(errorMessage, requestType));
        }
    };
}
//

//UPDATE DR. Signature
export const handleUpdateDR_SignVerfication = async ({ reqData, dispatch, type }) => {
    try {
        if (reqData.is_dr_sign_checked === 0) {
            dispatch(UpdateDRSign(0))
        }
        const response = await Axios.post(update_common_sig_prescription, reqData);
        safeToast.success('Doctor signature updated successfully')
        if (type === 'dr_sign') {
            dispatch(UpdateDRSign(response.data))
        }

        return { data: response.data, loading: false, error: null };
    } catch (error) {
        safeToast.error('An error occurred while updating doctor signature. Please try again.')
        return { data: '', loading: false, error: error.message };
    }
};

//Get Investigate Templates
export const fetchInvestigateTemplate = ({ templateName, drugName, setTemplateName, rxNumber }) => {
    return async (dispatch) => {
        setTemplateName('')
        try {
            const requestedData = {
                template_id: templateName,
                drug_name: drugName,
                rxnumber: [rxNumber]
            };

            const response = await Axios.post(pharmacy_investigate_getinvestigateTemplate, requestedData);

            if (response.status === 200) {
                setTemplateName(response?.data?.template || '')
            } else {
                throw new Error('Unexpected response status');
            }

        } catch (error) {
            setTemplateName('')
            safeToast.error('An issue occurred.')
        }
    };
};


//Get Investigate Templates
export const fetchInvestigateTemplateList = ({ templateName, drugName, setTemplateName, rxNumber }) => {
    return async (dispatch) => {
        setTemplateName('')
        try {
            const rxNumbersAsNumbers = rxNumber.map(item => parseInt(item.rxnumber));
            const requestedData = {
                template_id: templateName,
                drug_name: drugName,
                rxnumber: rxNumbersAsNumbers
            };

            const response = await Axios.post(pharmacy_investigate_getinvestigateTemplate_for_bulk, requestedData);

            if (response.status === 200) {
                setTemplateName(response?.data?.template || '')
            } else {
                throw new Error('Unexpected response status');
            }

        } catch (error) {
            setTemplateName('')
            safeToast.error('An issue occurred.')
        }
    };
};

//Update Investigate Templates
export const UpdateInvestigateRxPdF = ({ template_data, rxnumber, setLoading, onPharmacistNotFound }) => {
    return async (dispatch) => {
        try {
            setLoading(true)
            const requestedData = {
                template_data: template_data,
                rxnumber: rxnumber
            };
            const response = await Axios.post(pharmacy_save_pdf_template_data, requestedData);
            if (response.status === 200) {
                safeToast.success('Updated Successfully.')
                dispatch(fetchPatientInvestigationRxPDF({
                    rx: rxnumber,
                    requestType: 'investigation_pdf',
                }))
                setLoading(false)
                return { success: true, data: response?.data?.data }
            }
            setLoading(false)
            return { success: false, errorMessage: 'Unexpected response status' }
        } catch (error) {
            setLoading(false)
            const errorMessage = error?.response?.data?.data?.error || error?.response?.data?.message || 'An error occurred';
            const isPharmacistNotFound = typeof errorMessage === 'string' && errorMessage.toLowerCase().includes('pharmacist not found')

            if (isPharmacistNotFound && typeof onPharmacistNotFound === 'function') {
                onPharmacistNotFound(errorMessage)
                return { success: false, pharmacistNotFound: true, errorMessage }
            }

            safeToast.error(errorMessage)
            return { success: false, errorMessage }
        }
    };
};

export const previewWinRxEmergencyTemplatePdf = ({ requestData, requestType = 'investigation_pdf' }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post(pharmacy_preview_winrx_emergency_template_pdf, requestData);
            const payload = response?.data?.data || {};
            const results = Array.isArray(payload?.results) ? payload.results : [];
            const preview = Array.isArray(payload?.results)
                ? payload.results.find((item) => item?.requires_confirmation && item?.preview_pdf)
                : null;

            if (!preview?.preview_pdf) {
                const backendError = results.find((item) => item?.error)?.error;
                throw new Error(backendError || 'Emergency PDF preview is not available.');
            }

            dispatch(investigationRX_PDF_Success({
                encoded_pdf: preview.preview_pdf,
                is_file_exist: 1,
                is_winrx_emergency_template_preview: true,
            }, requestType));

            return { success: true };
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while previewing PDF template';
            showToast(errorMessage, 'error');
            return { success: false, errorMessage };
        }
    };
};

export const submitWinRxEmergencyTemplatePdf = ({ requestData, setLoading }) => {
    return async () => {
        try {
            if (typeof setLoading === 'function') {
                setLoading(true);
            }

            const response = await Axios.post(pharmacy_submit_winrx_emergency_template_pdf, requestData);

            if (response.status !== 200) {
                throw new Error('Unexpected response status');
            }

            showToast('PDF templates updated successfully!', 'success');
            return { success: true };
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while updating PDF templates';
            showToast(errorMessage, 'error');
            return { success: false, errorMessage };
        } finally {
            if (typeof setLoading === 'function') {
                setLoading(false);
            }
        }
    };
};

export const saveLoginPharmacistCpsid = async (payload) => {
    try {
        const response = await Axios.post(update_login_pharmacist_cpsid, payload)
        return response
    } catch (error) {
        throw error
    }
}


// The SIG check used to fetch the OpenAI key from the backend and call OpenAI
// from the browser, which exposed the key to every pharmacy user. The backend
// now makes the call (Azure OpenAI) through pharmacy_ai_chat.

//Check SIG for Changing Dose

// export const checkSIGforChangingDose = ({ requestType,
//     sigDetails,
//     patientDetails,
//     setIsChanging,
//     setFrequencyRows,
//     setFrequency,
//     setDoseInputs,
//     setHasChangingDoseData,
//     setChangingUpdateType,
//     setSelectedDaysArray,
//     setSelectedFQY
// }) => {

//     return async (dispatch) => {
//         try {
//             dispatch({ type: SIG_AI_REQUEST, payload: { requestType } });

//             const openAiKey = await fetchPharmacyOpenAiKey();

//             const rxId = patientDetails?.rxdata_id || null;
//             const for_non_dilaudid_drug = !patientDetails?.is_frequency
//             const isDwi = sigDetails?.toLowerCase()?.includes('dwi');
//             const daily_dose = patientDetails?.ddose || 0;
//             const is_dilaudid = patientDetails?.is_frequency === 1 ? true : false;
//             const currentYear = new Date().getFullYear();

//             const dosageRange = (sigText) => {
//                 if (!sigText) return false;
//                 // Convert to lowercase for case-insensitive matching
//                 const sig = sigText.toLowerCase();
//                 const rangePatterns = [
//                     /\d+\s*-\s*\d+\s*(tablets?|tabs?|TABLETS?|TABS?)/i,           // "1-3 tablets", "2 - 4 TABS", "1- 3 TABLET"
//                     /\d+\s+to\s+\d+\s*(tablets?|tabs?|TABLETS?|TABS?)/i,          // "1 to 3 TABLETS", "2 to 4 tabs"
//                     /take\s+\d+\s*-\s*\d+\s*(tablets?|tabs?|TABLETS?|TABS?)/i,    // "take 1-3 TABLETS", "take 2-4 tabs"
//                     /take\s+\d+\s+to\s+\d+\s*(tablets?|tabs?|TABLETS?|TABS?)/i    // "take 1 to 3 tablets", "take 2 to 4 TABS"
//                 ];
//                 // Check if any range pattern matches
//                 return rangePatterns.some(pattern => pattern.test(sig));
//             };

//             const isDosageRange = dosageRange(sigDetails);

//             const previousSigsWithDays = [
//                 "(16MAY-25MAY/26) INSTILL IN LEFT EAR TWICE DAILY. USE 2 DROPS IN LEFT EAR FOR 3 DAYS, THEN INCREASE TO 3 DROPS IN LEFT EAR TWICE DAILY FOR 7 DAYS. FOR EXTERNAL USE ONLY. KEEP OUT OF REACH OF CHILDREN.",
//                 "(20MAY-10JUN/26) APPLY TO AFFECTED SKIN AREA ONCE DAILY AT BEDTIME. APPLY A THIN LAYER FOR 5 DAYS, THEN APPLY A THICKER LAYER FOR 16 DAYS. WASH HANDS AFTER APPLICATION. DO NOT USE ON BROKEN SKIN.",
//                 "(25MAY-15JUN/26) TAKE ONE TABLET BY MOUTH ONCE DAILY. TAKE ONE TABLET EVERY OTHER DAY FOR THE FIRST 6 DAYS (TOTAL OF 3 TABLETS), THEN TAKE ONE TABLET DAILY FOR THE REMAINING 15 DAYS. STORE IN A COOL, DRY PLACE.",
//                 "(15MAY-24MAY/26) TAKE BY MOUTH ONCE DAILY. TAKE 5 ML (=25 MG) FOR 4 DAYS, THEN INCREASE TO 10 ML (=50 MG) FOR 6 DAYS. MAY CAUSE DROWSINESS.",
//                 "(17MAY-26MAY/26) TAKE BY MOUTH TWICE DAILY. TAKE 2.5 ML (=12.5 MG) IN THE MORNING AND 2.5 ML (=12.5 MG) IN THE EVENING FOR 3 DAYS, THEN 5 ML (=25 MG) IN THE MORNING AND 5 ML (=25 MG) IN THE EVENING FOR 7 DAYS. TAKE WITH FOOD.",
//                 "(21MAY-30MAY/26) TAKE BY MOUTH ONCE DAILY AT BEDTIME. TAKE 7.5 ML (=75 MG) FOR 5 DAYS, THEN DECREASE TO 5 ML (=50 MG) FOR 5 DAYS. AVOID ALCOHOL.",
//                 "(23MAY-06JUN/26) INSTILL IN RIGHT NOSTRIL ONCE DAILY. INSTILL 0.5 ML (=2.5 MG) FOR 3 DAYS, THEN 1 ML (=5 MG) FOR 14 DAYS. SHAKE WELL BEFORE USE.",
//                 "(25MAY-03JUN/26) TAKE BY MOUTH THREE TIMES A DAY. TAKE 3 ML (=15 MG) THREE TIMES A DAY FOR 4 DAYS, THEN 4 ML (=20 MG) THREE TIMES A DAY FOR 5 DAYS. DRINK PLENTY OF WATER.",
//                 "(27MAY-05JUN/26) APPLY TO AFFECTED AREA ONCE DAILY. APPLY 1.5 ML (=7.5 MG) FOR 4 DAYS, THEN 2.5 ML (=12.5 MG) FOR 5 DAYS. DO NOT COVER WITH BANDAGE UNLESS INSTRUCTED.",
//                 "(29MAY-07JUN/26) TAKE BY MOUTH TWICE DAILY. TAKE 4 ML (=20 MG) IN THE MORNING AND 4 ML (=20 MG) AT NIGHT FOR 5 DAYS, THEN 5 ML (=25 MG) IN THE MORNING AND 5 ML (=25 MG) AT NIGHT FOR 4 DAYS.",
//                 "(02JUN-11JUN/26) TAKE BY MOUTH ONCE DAILY. TAKE 6 ML (=30 MG) FOR 5 DAYS, THEN INCREASE TO 8 ML (=40 MG) FOR 5 DAYS. STORE AT ROOM TEMPERATURE.",
//                 "[19 JUN - 20 JUL/26] *DWI* INCREASING DOSE-TAKE 3 CAPS(=300MG)BY MOUTH DAILY INCREASE 1 CAP* DAILY UNTIL DOSE REACH 7CAPS(700MG)",
//                 "*UP-TITRATION* (19JUN-16JULY/26)**DWI** DRINK 9.5ML(=95MG)X2DAYS,10.5ML(=105MG)X4DAYS,11.5ML(=115MG)X 7DAYS, 12.5ML(=125MG)X15DAYS BY MOUTH DAILY. DANGEROUS FATAL FOR CHILDREN.",
//                 "UP-TITRATION (27JUN-16JULY/26) DWI- DRINK 4 MLS(=40 MGS) BY MOUTH DAILY FOR OAT FOR 2DAYS, THEN 5.5ML(=55MGS)FOR 4DAYS, THEN 7ML(=70MG) FOR 7DAYS, THEN 8.5ML(=85MG) FOR 7DAYS BY MOUTH DAILY. DANGEROUS FATAL FOR CHILDREN",
//                 "*UP-TITRATION*TRFX(16JULY-06AUG/26)*DWI* DRINK 3.5MLS(=35MGS)X3DAYS, 4.5ML(=45MGS)X3DAYS, 5.5ML(=55MGS) X16 DAYS BY MOUTH DAILY FOR OAT. ORANGE TANG ADDED TO MAKE 100ML. *NEW ON METHADOSE*",
//                 "*UP-TITRATION*TRFX(17JULY-06AUG/26)*DWI* DRINK 8.5MLS (=85MG) MOUTH DAILY FOR 3DAYS,9.5ML (=95MG) FOR 4DAYS, 10.5ML (=105MG) FOR 7DAYS, 12.5ML(=125MG) FOR 7 DAYS. ORANGE TANG ADDED TO MAKE 100ML FOR OAT."
//             ];

//             const systemPrompt = `
//             You are a helper that analyzes a prescription SIG code and returns structured JSON for a medication schedule.
//             ---

//             🔹 Task 1: Detect Changing Dose
//                 Determine whether the SIG indicates a **changing dose over time**, based on durations **measured in days**.

//                 A "changing dose" is true only if the SIG specifies different dosages, frequencies, or strengths for distinct durations. Look for clues such as:
//                 - "for 5 days, then for 7 days"
//                 - "then increase"
//                 - "then decrease"
//                 - "for X days, then..."

//                 ✅ Examples:
//                 ${previousSigsWithDays.filter(sig => sig.includes('DAYS') && (sig.includes('THEN INCREASE') || sig.includes('THEN DECREASE') || sig.includes(', THEN'))).join('; ')}

//                 ❌ Do **NOT** consider these:
//                 - Generic labels like "TITRATE", "DOSE INCREASE", etc., if not part of the actual SIG
//                 - PRN (as needed) instructions
//                 - Changes based on **hours** instead of **days**

//                 ---

//             🔹 Task 2: Extract Start and End Dates
//                 If the SIG contains a **date range**, extract and convert it into this ISO format: 'YYYY-MM-DD'.
//                 - Recognize formats like:
//                 - "(29APR-10JUN/26)" or "(29APR-10JUN/26)"
//                 - "10JAN26 to 20FEB26"
//                 - "01/10/2026 – 01/25/2026"

//                 - Convert short-form dates using the **current year rule**: The current year is ${currentYear}. When the SIG has a 2-digit year (e.g. /26, /25, 26, 25), interpret it as 20XX. So "/26" or "26" → ${currentYear}, "/25" or "25" → ${currentYear - 1}, "/27" or "27" → ${currentYear + 1}.
//                 - Examples (when current year is ${currentYear}):
//                 - "29APR/26" → "${currentYear}-04-29"
//                 - "10JUN/26" → "${currentYear}-06-10"
//                 - "10JAN26" → "${currentYear}-01-10"
//                 - "29APR/25" → "${currentYear - 1}-04-29"

//                 - If a date is unparseable, return "null".

//                 ---

//             🔹 Task 3: If changingDose is true → return schedule in this structure

//             schedule : {
//                 "is_changing": true,
//                 "rxes_id": ${rxId},
//                 "frequency": [
//                 {
//                     "frequency": "OD",
//                     "dose": ["35"],
//                     "days": 20,
//                 },
//                 {
//                     "frequency": "OD",
//                     "dose": ["35"],
//                     "days": 1,
//                 }
//                 ]
//             }
//                 ✅ Critical Clarification:
//             - Always extract the **value**, not the value inside parentheses
//                 - For example:
//                 - "DRINK 4.5ML(=45MG)" → dose = "4.5"
//                 - "GIVE 3 ML (=30 MG)" → dose = "3"
//                 - "APPLY 1.5 ML (=7.5 MG)" → dose = "1.5"
//                 - "TAKE 2.5 ML (=12.5 MG)" → dose = "2.5"
//                 - "3ML(30MG)" → dose = "3"
//                 - "4 MLS(=40 MGS)" → dose = "4"
//                 - "8.5MLS (=85MG)" → dose = "8.5"
//                 - "9.5ML (=95MG)" → dose = "9.5"
//                 - "12.5ML(=125MG)" → dose = "12.5"
//                 - "10.5ML (=105MG)" → dose = "10.5"

//                 ✅ Rules:
//                 - frequency is always "OD"
//                 - dose is always an array of numbers as strings (no units like mL, mg, etc.)
//                 - days must be integer
//                 - cycle_no starts at 1 and increments
//                 - Return null if schedule cannot be confidently parsed
//                 ---


//                 🔹 Task 4: Extract Scheduled Days from SIG (Weekly Days Parser)

//                 If the SIG includes scheduled weekdays (e.g., "M/W/F", "MON, WED, FRI", "EVERY TUESDAY"), extract and return them in this structure:

//                 "scheduled_days": {
//                 "Sunday": 0,
//                 "Monday": 1,
//                 "Tuesday": 0,
//                 "Wednesday": 1,
//                 "Thursday": 0,
//                 "Friday": 1,
//                 "Saturday": 1
//                 }

//                 ✅ Map:
//                 - MON or MONDAY → Monday  
//                 - TUE or TUESDAY → Tuesday  
//                 - WED or WEDNESDAY → Wednesday  
//                 - TH or THU or THURSDAY → Thursday  
//                 - FRI or FRIDAY → Friday  
//                 - SAT or SATURDAY → Saturday  
//                 - SU or SUN or SUNDAY → Sunday

//                 - "M/W/F" → Monday, Wednesday, Friday
//                 - "MON, WED, FRI" → Monday, Wednesday, Friday
//                 - "EVERY TUESDAY" → Tuesday

//                 Set value to 1 for days mentioned, 0 otherwise.  
//                 Return "scheduled_days" as part of final JSON even if no days are found (default all 0s).

//                 ${isDwi && isDosageRange && is_dilaudid && `
//                     🔹 Task 5: Parse SIG and Calculate Tablet Distribution

//                     If the SIG contains the keyword "DWI" or "*DWI-ALL-DOSES*" (case-insensitive) AND it contains a dosage range such as:
//                     - "1-3 tablets"
//                     - "2-4 tabs"
//                     - "take 2 to 5 tablets"
//                     - "take 2-5 tabs"
//                     - "TAKE 1-3 TABLETS"

//                     Then follow these rules to compute the tablet_distribution:

//                     📌 Rules:
//                     1. Extract the **min** and **max** values from the dosage range.
//                        - E.g., "2-4 tablets" → min = 2, max = 4
//                        - E.g., "1-3 TABLETS" → min = 1, max = 3
//                        - E.g., "take 2 to 5 tablets" → min = 2, max = 5
//                     2. Use the max value as many times as possible from the total available tablets (daily_dose = ${daily_dose})
//                     3. If remaining tablets are ≥ min, add that as the final dose.
//                     4. If remaining < min, discard the remainder.
//                     5. The goal is to use max dose safely and reduce tablet counts.

//                     ✅ Examples:
//                     - "2-4 tablets", daily_dose = 14 → [4, 4, 4, 2]
//                     - "2-5 tablets", daily_dose = 14 → [5, 5, 4]
//                     - "2-7 tablets", daily_dose = 14 → [7, 7]
//                     - "1-3 tablets", daily_dose = 10 → [3, 3, 3, 1]
//                     - "1-3 tablets", daily_dose = 8 → [3, 3, 2]
//                     - "1-3 tablets", daily_dose = 5 → [3, 2]
//                     - "1-3 tablets", daily_dose = 2 → [2]
//                     - "1-3 tablets", daily_dose = 1 → [1]
//                     - "2-4 tablets", daily_dose = 12 → [4, 4, 4]
//                     - "1-2 tablets", daily_dose = 7 → [2, 2, 2, 1]

//                     🚨 CRITICAL WARNING: 
//                     - You MUST ALWAYS return tablet_distribution as an array with actual values
//                     - NEVER return null, undefined, or empty array []
//                     - If you cannot parse the dosage range
//                     - ALWAYS calculate and return a valid tablet_distribution array
//                     - For daily_dose = ${daily_dose}, you MUST return a non-empty array

//                     ⛔ Do NOT distribute using min value repeatedly. Always prioritize max dosing.
//                     ✅ Return this field:
//                     {
//                       "tablet_distribution": [4, 4, 4, 2]
//                     }
//                 `}

//                 ✅ Final Output Format (strict JSON):
//                 {
//                     changingDose: true | false,
//                     startDate: "YYYY-MM-DD" | null,
//                     endDate: "YYYY-MM-DD" | null,
//                     schedule: object | null,
//                     scheduled_days: object | null
//                     tablet_distribution: array | []
//                 }

//                 ⚠️ Output must be strict JSON. No explanation, comments, or formatting issues.`;

//             const payload = {
//                 model: 'gpt-5-mini',
//                 response_format: { type: "json_object" },
//                 messages: [
//                     {
//                         role: 'system',
//                         content: systemPrompt
//                     },
//                     {
//                         role: 'user',
//                         content: sigDetails
//                     }
//                 ],
//                 max_completion_tokens: 500,
//                 // temperature: 0.2,
//                 // n: 1
//             };

//             const response = await axios.post('https://api.openai.com/v1/chat/completions', payload, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${openAiKey}`
//                     // 'Authorization': `Bearer ${process.env.REACT_APP_AI_KEY}`
//                 }
//             });

//             let aiResponse;
//             try {
//                 const raw = response.data.choices?.[0]?.message?.content;
//                 console.log('raw', raw);
//                 console.log('response', response);
//                 aiResponse = JSON.parse(raw);
//                 console.log('aiResponse', aiResponse);

//                 if (!aiResponse || typeof aiResponse !== 'object') throw new Error('Invalid AI response');

//                 const payload = {
//                     rxes_id: rxId,
//                     is_front_sig_check: 1
//                 }

//                 processSIGWithAI(payload)

//                 dispatch({
//                     type: SIG_AI_SUCCESS,
//                     payload: {
//                         data: {
//                             changingDose: aiResponse.changingDose,
//                             startDate: aiResponse.startDate,
//                             endDate: aiResponse.endDate,
//                             schedule: aiResponse.schedule,
//                             scheduled_days: aiResponse.scheduled_days
//                         },
//                         requestType
//                     }
//                 });

//                 if (Number(patientDetails?.is_single_dispense) !== 1) {
//                     //Dilaudid Tablet Distribution
//                     if (aiResponse?.tablet_distribution?.length > 0 && isDwi) {
//                         const daily_dose_distribution = aiResponse?.tablet_distribution || [];
//                         const daily_dose_distribution_sum = daily_dose_distribution.reduce((acc, curr) => acc + parseFloat(curr), 0);

//                         // Frequency label mapping
//                         const frequencyMap = {
//                             1: 'OD',
//                             2: 'BID',
//                             3: 'TID',
//                             4: 'QID',
//                             5: '5x',
//                             6: '6x',
//                             7: '7x'
//                         }

//                         const distribution_length = daily_dose_distribution.length;
//                         const detected_frequency = frequencyMap[distribution_length] || null;

//                         if (parseFloat(daily_dose_distribution_sum) === parseFloat(daily_dose) && detected_frequency) {
//                             const totalDays = calculateDaysSupply(patientDetails)
//                             const duration = totalDays > 0 ? totalDays : patientDetails?.prescription_detail?.day_supply

//                             const dose_rows = (daily_dose_distribution || []).map(d => ({ dose: String(d ?? ''), iv_code: '' }));
//                             const frequencyData = [
//                                 {
//                                     frequency: detected_frequency,
//                                     dose: daily_dose_distribution,
//                                     dose_rows,
//                                     days: duration,
//                                 }
//                             ];

//                             const getFrequencyData = {
//                                 get_requency_data: {
//                                     is_changing: false,
//                                     rxes_id: rxId,
//                                     frequency: frequencyData
//                                 }
//                             }

//                             const payload = {
//                                 frequency: frequencyData.map(f => ({
//                                     frequency: f.frequency,
//                                     dose_rows: f.dose_rows || (f.dose || []).map(d => ({ dose: String(d), iv_code: '' })),
//                                     days: f.days
//                                 })),
//                                 rxes_id: rxId,
//                                 is_changing: false,
//                                 is_non_dilaudid: for_non_dilaudid_drug ? false : true,
//                                 update_type: 'system'
//                             }

//                             const sharedParams = {
//                                 patientDetails: getFrequencyData,
//                                 setIsChanging,
//                                 setFrequencyRows,
//                                 setFrequency,
//                                 setDoseInputs,
//                                 setHasChangingDoseData,
//                                 setChangingUpdateType
//                             };

//                             handleGetChangingDoseData(sharedParams);
//                             dispatch(handleUpdateFrequencyQty({
//                                 payload,
//                                 ...sharedParams,
//                                 type: 'update_frequency_qty'
//                             }));
//                         }
//                     }
//                     //Updating Changing Dose
//                     else if (aiResponse?.schedule) {
//                         const totalQty = parseFloat(patientDetails?.prescription_detail?.quantity_authorized)
//                         let ai_total_qty = 0;

//                         aiResponse?.schedule?.frequency
//                             .flatMap((entry) => {
//                                 const days = parseInt(entry.days);
//                                 return entry.dose.map((doseVal) => {
//                                     const dose = parseFloat(doseVal);
//                                     const total = dose * days;
//                                     ai_total_qty += total;
//                                     return `${dose} * ${days} = ${total}`;
//                                 });
//                             })
//                             .join('\n');

//                         const frequencyWithDoseRows = (aiResponse?.schedule?.frequency || []).map(row => ({
//                             ...row,
//                             dose_rows: Array.isArray(row.dose_rows) && row.dose_rows.length > 0
//                                 ? row.dose_rows.map(dr => ({ id: dr.id, dose: String(dr.dose ?? ''), iv_code: dr.iv_code ?? '' }))
//                                 : (row.dose || []).map(d => ({ dose: String(d ?? ''), iv_code: '' }))
//                         }));

//                         const getFrequencyData = {
//                             get_requency_data: {
//                                 is_changing: aiResponse?.schedule?.is_changing,
//                                 rxes_id: rxId,
//                                 frequency: frequencyWithDoseRows
//                             }
//                         }

//                         const frequencyData = frequencyWithDoseRows.map(row => ({
//                             frequency: row?.frequency,
//                             dose_rows: row.dose_rows,
//                             days: row?.days,
//                             ...(row.cycle_no != null && { cycle_no: row.cycle_no })
//                         }));

//                         const payload = {
//                             frequency: frequencyData,
//                             rxes_id: rxId,
//                             is_changing: true,
//                             is_non_dilaudid: for_non_dilaudid_drug ? false : true,
//                             update_type: 'system'
//                         }

//                         const shouldUpdateForNonDilaudid = (for_non_dilaudid_drug && ai_total_qty === totalQty);

//                         const isFentanyl = patientDetails.is_fentanyl === 1;
//                         const totalDays = calculateTotalDays(aiResponse?.schedule?.frequency);
//                         const daysSupply = patientDetails?.prescription_detail?.day_supply;
//                         const shouldUpdateForFentanyl = (isFentanyl && (Number(totalDays) === Number(daysSupply)));

//                         if (shouldUpdateForNonDilaudid || shouldUpdateForFentanyl) {
//                             const sharedParams = {
//                                 patientDetails: getFrequencyData,
//                                 setIsChanging,
//                                 setFrequencyRows,
//                                 setFrequency,
//                                 setDoseInputs,
//                                 setHasChangingDoseData,
//                                 setChangingUpdateType
//                             };

//                             handleGetChangingDoseData(sharedParams);
//                             dispatch(handleUpdateFrequencyQty({
//                                 payload,
//                                 ...sharedParams,
//                                 type: 'update_frequency_qty'
//                             }));
//                             // setSelectedFQY('changing')
//                         }
//                     }
//                 }

//                 //Update Schedule Days
//                 if (aiResponse?.scheduled_days && !patientDetails?.billing_frequency) {
//                     const isDefaultDaysChecked = Object.values(aiResponse?.scheduled_days)?.some(value => Number(value) === 1)
//                     const alreadyScheduledDays = Object.values(patientDetails?.route_detail?.scheduled_days)?.some(value => Number(value) === 1)
//                     if (alreadyScheduledDays) return;
//                     if (isDefaultDaysChecked) {
//                         const payload = {
//                             "rxnumber": patientDetails?.rxnumber,
//                             "days": aiResponse.scheduled_days
//                         }
//                         const selected = Object.entries(aiResponse?.scheduled_days)
//                             .filter(([day, isSelected]) => isSelected === 1)
//                             .map(([day]) => day);

//                         setSelectedDaysArray(selected)
//                         dispatch(HandleUpdateSchedule({ payload, showToaster: true }))
//                     }
//                 }

//                 return {
//                     changingDose: aiResponse.changingDose,
//                     startDate: aiResponse.startDate,
//                     endDate: aiResponse.endDate,
//                     schedule: aiResponse.schedule,
//                     scheduled_days: aiResponse.scheduled_days,
//                     tablet_distribution: aiResponse?.tablet_distribution,
//                 };

//             } catch (parseError) {
//                 dispatch({
//                     type: SIG_AI_FAILURE,
//                     payload: { error: 'Failed to parse AI response', requestType }
//                 });
//                 return { changingDose: false };
//             }

//         } catch (error) {
//             dispatch({
//                 type: SIG_AI_FAILURE,
//                 payload: { error: error.message, requestType }
//             });
//             return { changingDose: false };
//         }
//     };
// }


export const checkSIGforChangingDose = ({
    requestType,
    sigDetails,
    patientDetails,
    setIsChanging,
    setFrequencyRows,
    setFrequency,
    setDoseInputs,
    setHasChangingDoseData,
    setChangingUpdateType,
    setSelectedDaysArray,
    setSelectedFQY
}) => {

    return async (dispatch, getState) => {

        try {

            dispatch({ type: SIG_AI_REQUEST, payload: { requestType } });

            const rxId = patientDetails?.rxdata_id || null;
            const for_non_dilaudid_drug = !patientDetails?.is_frequency
            const isDwi = sigDetails?.toLowerCase()?.includes('dwi');
            const daily_dose = patientDetails?.ddose || 0;
            // const is_dilaudid = patientDetails?.is_frequency === 1 ? true : false;

            // const optimizedPrompt = `
            //     You are a medical prescription SIG parser.

            //     Your job is to analyze a prescription instruction (SIG) and return structured JSON.

            //     RULES

            //     1. Detect Changing Dose
            //     changingDose = true only if the SIG clearly shows different doses for different day durations.

            //     Examples:
            //     TAKE 5ML FOR 5 DAYS THEN 10ML FOR 7 DAYS → true
            //     *UP-TITRATION*TRFX(17JULY-06AUG/26)*DWI* DRINK 8.5MLS (=85MG) MOUTH DAILY FOR 3DAYS,9.5ML (=95MG) FOR 4DAYS, 10.5ML (=105MG) FOR 7DAYS, 12.5ML(=125MG) FOR 7 DAYS. ORANGE TANG ADDED TO MAKE 100ML FOR OAT. -> true
            //     TAKE ONE TABLET DAILY → false

            //     2. Extract Start and End Dates

            //     Recognize formats:
            //     (29APR-10JUN/26)
            //     29APR26-10JUN26
            //     01/10/2026 – 01/25/2026

            //     Convert to:
            //     YYYY-MM-DD

            //     2 digit year rule:
            //     26 → 2026
            //     25 → 2025
            //     27 → 2027

            //     If cannot parse return null.

            //     3. Changing Dose Schedule

            //     schedule:{
            //     "is_changing":true,
            //     "rxes_id":${rxId},
            //     "frequency":[
            //     {
            //     "frequency":"OD",
            //     "dose":["5"],
            //     "days":5
            //     },
            //     {
            //     "frequency":"OD",
            //     "dose":["10"],
            //     "days":7
            //     }
            //     ]
            //     }

            //     Rules:
            //     • frequency always "OD"
            //     • remove units (ml mg tablets)
            //     • dose numbers as strings
            //     • days integer

            //     Example:
            //     DRINK 4.5ML (=45MG) → dose "4.5"

            //     4. Scheduled Week Days

            //     Return:

            //     "scheduled_days":{
            //     "Sunday":0,
            //     "Monday":0,
            //     "Tuesday":0,
            //     "Wednesday":0,
            //     "Thursday":0,
            //     "Friday":0,
            //     "Saturday":0
            //     }

            //     Example:
            //     M/W/F → Monday=1 Wednesday=1 Friday=1

            //     5. Tablet Distribution

            //     If SIG contains "DWI" AND a tablet range like "1-3 tablets":

            //     Example:
            //     daily_dose = ${patientDetails?.ddose || 0}

            //     1-3 tablets → [3,3,3,1]

            //     Return array as "tablet_distribution".

            //     FINAL OUTPUT

            //     Return STRICT JSON ONLY:

            //     {
            //     "changingDose":true|false,
            //     "startDate":"YYYY-MM-DD"|null,
            //     "endDate":"YYYY-MM-DD"|null,
            //     "schedule":object|null,
            //     "scheduled_days":object,
            //     "tablet_distribution":[]
            //     }

            //     No explanation.
            //     No markdown.
            //     Only JSON.
            //     `;

            const optimizedPrompt = `
            You are a medical prescription SIG parser.

            Your job is to analyze a prescription instruction (SIG) and return structured JSON only.

            RULES

            1. Detect Changing Dose
            Set "changingDose" = true only if the SIG clearly shows different doses for different day durations.

            Examples:
            - TAKE 5ML FOR 5 DAYS THEN 10ML FOR 7 DAYS -> true
            - *UP-TITRATION*TRFX(17JULY-06AUG/26)*DWI* DRINK 8.5MLS (=85MG) MOUTH DAILY FOR 3DAYS,9.5ML (=95MG) FOR 4DAYS, 10.5ML (=105MG) FOR 7DAYS, 12.5ML(=125MG) FOR 7 DAYS. ORANGE TANG ADDED TO MAKE 100ML FOR OAT. -> true
            - TAKE ONE TABLET DAILY -> false
            - (11MAR-07APRIL)*DWI* TAKE 3 CAPSULES (=300 MGS) BY MOUTH DAILY FOR OAT. POISONOUS IF INGESTED BY OTHERS. -> false

            2. Extract Start and End Dates

            Recognize formats such as:
            - (29APR-10JUN/26)
            - 29APR26-10JUN26
            - 01/10/2026 - 01/25/2026
            - (11MAR-07APRIL)
            - (11MAR-07APR)
            - 11MAR-07APR

            Convert to:
            YYYY-MM-DD

            Year parsing rules:
            - If a 2-digit year is explicitly present in the SIG, convert it directly:
            26 -> 2026
            27 -> 2027
            - If a 4-digit year is explicitly present in the SIG, use it directly.
            - If NO year is present anywhere in the SIG date, ALWAYS use the current year.
            - Never infer a previous year when the year is missing.
            - Never infer the year from whether the month/day has already passed.
            - Never roll backward to an older year unless the SIG explicitly contains that year.
            - Example:
            (11MAR-07APRIL) with no year in SIG -> use current year only.

            If cannot parse, return null.

            3. Changing Dose Schedule

            Return:
            "schedule": {
            "is_changing": true,
            "rxes_id": ${rxId},
            "frequency": [
                {
                "frequency": "OD",
                "dose": ["5"],
                "days": 5
                },
                {
                "frequency": "OD",
                "dose": ["10"],
                "days": 7
                }
            ]
            }

            Rules:
            - frequency is always "OD"
            - remove dose units such as ml, mls, mg, mgs, tablet, tablets, capsule, capsules
            - dose values must be strings
            - days must be integer
            - If SIG is not a changing-dose SIG, return schedule = null

            Example:
            DRINK 4.5ML (=45MG) -> dose "4.5"

            4. Scheduled Week Days

            Return:
            "scheduled_days": {
            "Sunday": 0,
            "Monday": 0,
            "Tuesday": 0,
            "Wednesday": 0,
            "Thursday": 0,
            "Friday": 0,
            "Saturday": 0
            }

            Rules:
            - Mark 1 only for explicitly mentioned scheduled weekdays
            - Example: M/W/F -> Monday=1, Wednesday=1, Friday=1
            - If no weekdays are explicitly mentioned, all values must remain 0

            5. Tablet Distribution

            Only if SIG contains "DWI" and a tablet range like "1-3 tablets":
            - Use daily_dose = ${patientDetails?.ddose || 0}
            - Example:
            1-3 tablets -> [3,3,3,1]
            - Return this as "tablet_distribution"

            If no such tablet range exists, return an empty array.

            FINAL OUTPUT

            Return STRICT JSON ONLY in this exact shape:

            {
            "changingDose": true,
            "startDate": "YYYY-MM-DD",
            "endDate": "YYYY-MM-DD",
            "schedule": null,
            "scheduled_days": {
                "Sunday": 0,
                "Monday": 0,
                "Tuesday": 0,
                "Wednesday": 0,
                "Thursday": 0,
                "Friday": 0,
                "Saturday": 0
            },
            "tablet_distribution": []
            }

            Do not return explanation.
            Do not return markdown.
            Do not return code fences.
            Return JSON only.
            `;

            const payload = {
                model: "gpt-5-mini",
                response_format: { type: "json_object" },
                messages: [
                    { role: "system", content: optimizedPrompt },
                    { role: "user", content: sigDetails }
                ],
                max_completion_tokens: 3000
            };

            const response = await Axios.post(pharmacy_ai_chat, payload);

            let aiResponse;

            try {

                const raw = response.data?.choices?.[0]?.message?.content || "";
                const cleaned = raw
                    .replace(/```json/g, "")
                    .replace(/```/g, "")
                    .trim();

                aiResponse = JSON.parse(cleaned);
                if (!aiResponse || typeof aiResponse !== 'object') throw new Error('Invalid AI response');

                // The AI may put this Rx on Changing only when no pharmacist has
                // entered doses for it.
                const aiSaysChanging = aiResponse.changingDose === true && canAiSetChangingDose(patientDetails);

                const payload = {
                    rxes_id: rxId,
                    is_front_sig_check: 1,
                    // Remembered on the server so the Rx still opens on Changing
                    // after a refresh; never sent as "not changing".
                    ...(aiSaysChanging && { is_ai_changing_dose: 1 })
                }

                processSIGWithAI(payload)

                // The AI takes a few seconds. If the pharmacist has moved to another
                // Rx meanwhile, this answer is still saved against its own Rx but
                // must not be written into the Rx now on screen.
                const openRxId = getState()?.investigateRX?.patientPrescriptionDetails?.data?.data?.rxdata_id;
                const isRxStillOpen = Number(openRxId) === Number(rxId);
                const forOpenRx = (setter) => (isRxStillOpen && typeof setter === 'function' ? setter : () => { });

                setIsChanging = forOpenRx(setIsChanging);
                setFrequencyRows = forOpenRx(setFrequencyRows);
                setFrequency = forOpenRx(setFrequency);
                setDoseInputs = forOpenRx(setDoseInputs);
                setHasChangingDoseData = forOpenRx(setHasChangingDoseData);
                setChangingUpdateType = forOpenRx(setChangingUpdateType);
                setSelectedDaysArray = forOpenRx(setSelectedDaysArray);

                if (isRxStillOpen) {
                    dispatch({
                        type: SIG_AI_SUCCESS,
                        payload: {
                            data: {
                                changingDose: aiResponse.changingDose,
                                startDate: aiResponse.startDate,
                                endDate: aiResponse.endDate,
                                schedule: aiResponse.schedule,
                                scheduled_days: aiResponse.scheduled_days
                            },
                            requestType
                        }
                    });
                }

                if (Number(patientDetails?.is_single_dispense) !== 1) {
                    let savedTabletDistribution = false;
                    let savedAiSchedule = false;

                    //Dilaudid Tablet Distribution
                    if (aiResponse?.tablet_distribution?.length > 0 && isDwi) {
                        const daily_dose_distribution = aiResponse?.tablet_distribution || [];
                        const daily_dose_distribution_sum = daily_dose_distribution.reduce((acc, curr) => acc + parseFloat(curr), 0);

                        // Frequency label mapping
                        const frequencyMap = {
                            1: 'OD',
                            2: 'BID',
                            3: 'TID',
                            4: 'QID',
                            5: '5x',
                            6: '6x',
                            7: '7x'
                        }

                        const distribution_length = daily_dose_distribution.length;
                        const detected_frequency = frequencyMap[distribution_length] || null;

                        if (parseFloat(daily_dose_distribution_sum) === parseFloat(daily_dose) && detected_frequency) {
                            const totalDays = calculateDaysSupply(patientDetails)
                            const duration = totalDays > 0 ? totalDays : patientDetails?.prescription_detail?.day_supply

                            const dose_rows = (daily_dose_distribution || []).map(d => ({ dose: String(d ?? ''), iv_code: '' }));
                            const frequencyData = [
                                {
                                    frequency: detected_frequency,
                                    dose: daily_dose_distribution,
                                    dose_rows,
                                    days: duration,
                                }
                            ];

                            const getFrequencyData = {
                                get_requency_data: {
                                    is_changing: false,
                                    rxes_id: rxId,
                                    frequency: frequencyData
                                }
                            }

                            const payload = {
                                frequency: frequencyData.map(f => ({
                                    frequency: f.frequency,
                                    dose_rows: f.dose_rows || (f.dose || []).map(d => ({ dose: String(d), iv_code: '' })),
                                    days: f.days
                                })),
                                rxes_id: rxId,
                                is_changing: false,
                                is_non_dilaudid: for_non_dilaudid_drug ? false : true,
                                update_type: 'system'
                            }

                            const sharedParams = {
                                patientDetails: getFrequencyData,
                                setIsChanging,
                                setFrequencyRows,
                                setFrequency,
                                setDoseInputs,
                                setHasChangingDoseData,
                                setChangingUpdateType
                            };

                            handleGetChangingDoseData(sharedParams);
                            dispatch(handleUpdateFrequencyQty({
                                payload,
                                ...sharedParams,
                                type: 'update_frequency_qty'
                            }));
                            savedTabletDistribution = true;
                        }
                    }

                    //Updating Changing Dose
                    const frequencyWithDoseRows = savedTabletDistribution
                        ? null
                        : normalizeAiChangingSchedule(aiResponse?.schedule);

                    if (frequencyWithDoseRows) {
                        const getFrequencyData = {
                            get_requency_data: {
                                is_changing: true,
                                rxes_id: rxId,
                                frequency: frequencyWithDoseRows
                            }
                        }

                        const frequencyData = frequencyWithDoseRows.map(row => ({
                            frequency: row?.frequency,
                            dose_rows: row.dose_rows,
                            days: row?.days,
                            ...(row.cycle_no != null && { cycle_no: row.cycle_no })
                        }));

                        const payload = {
                            frequency: frequencyData,
                            rxes_id: rxId,
                            is_changing: true,
                            is_non_dilaudid: for_non_dilaudid_drug ? false : true,
                            update_type: 'system'
                        }

                        const shouldSaveAiSchedule = shouldAutoSaveAiChangingSchedule({
                            rows: frequencyWithDoseRows,
                            isNonDilaudid: for_non_dilaudid_drug,
                            isFentanyl: patientDetails.is_fentanyl === 1,
                            authorizedQty: patientDetails?.prescription_detail?.quantity_authorized,
                            daySupply: patientDetails?.prescription_detail?.day_supply
                        });

                        if (shouldSaveAiSchedule) {
                            const sharedParams = {
                                patientDetails: getFrequencyData,
                                setIsChanging,
                                setFrequencyRows,
                                setFrequency,
                                setDoseInputs,
                                setHasChangingDoseData,
                                setChangingUpdateType
                            };

                            handleGetChangingDoseData(sharedParams);
                            dispatch(handleUpdateFrequencyQty({
                                payload,
                                ...sharedParams,
                                type: 'update_frequency_qty',
                                // Hand the saved schedule to the page so Select FQY
                                // switches to Changing now, not only after a refresh.
                                onSuccess: (saved) => dispatch(updatePrescriptionFrequencyLocal(rxId, saved?.data))
                            }));
                            savedAiSchedule = true;
                        }
                    }

                    // Changing dose, but the steps were not saved (they do not add
                    // up to the authorized quantity, or could not be read): put the
                    // page on Changing and leave the doses empty. AI doses are only
                    // ever entered when they match and are saved.
                    if (isRxStillOpen && aiSaysChanging && !savedAiSchedule && !savedTabletDistribution) {
                        dispatch(markPrescriptionAiChangingLocal(rxId));
                    }
                }

                //Update Schedule Days
                if (aiResponse?.scheduled_days && !patientDetails?.billing_frequency) {
                    const isDefaultDaysChecked = Object.values(aiResponse?.scheduled_days)?.some(value => Number(value) === 1)
                    const alreadyScheduledDays = Object.values(patientDetails?.route_detail?.scheduled_days)?.some(value => Number(value) === 1)
                    if (alreadyScheduledDays) return;
                    if (isDefaultDaysChecked) {
                        const payload = {
                            "rxnumber": patientDetails?.rxnumber,
                            "days": aiResponse.scheduled_days
                        }
                        const selected = Object.entries(aiResponse?.scheduled_days)
                            .filter(([day, isSelected]) => isSelected === 1)
                            .map(([day]) => day);

                        setSelectedDaysArray(selected)
                        dispatch(HandleUpdateSchedule({ payload, showToaster: true }))
                    }
                }

                return {
                    changingDose: aiResponse.changingDose,
                    startDate: aiResponse.startDate,
                    endDate: aiResponse.endDate,
                    schedule: aiResponse.schedule,
                    scheduled_days: aiResponse.scheduled_days,
                    tablet_distribution: aiResponse?.tablet_distribution,
                };

            } catch (parseError) {

                // console.error("AI JSON parse failed", parseError);

                dispatch({
                    type: SIG_AI_FAILURE,
                    payload: { error: "Failed to parse AI response", requestType }
                });

                return { changingDose: false };

            }
        } catch (error) {

            dispatch({
                type: SIG_AI_FAILURE,
                payload: { error: error.message, requestType }
            });

            return { changingDose: false };

        }
    };
};

//Check Bridge Connection
export const checkBridgeConnectionRequest = (requestType) => ({
    type: CHECK_BRIDGE_CONNECTION_REQUEST,
    payload: { requestType },
});

export const checkBridgeConnectionSuccess = (data, requestType) => ({
    type: CHECK_BRIDGE_CONNECTION_SUCCESS,
    payload: { data, requestType },
});

export const checkBridgeConnectionFailure = (error, requestType) => ({
    type: CHECK_BRIDGE_CONNECTION_FAILURE,
    payload: { error, requestType },
});

export const handleCheckBridgeConnection = ({ requestType }) => {
    return async (dispatch) => {
        try {
            dispatch(checkBridgeConnectionRequest(requestType));
            const response = await Axios.get(check_bridge_connection);
            if (response.status === 200) {
                dispatch(checkBridgeConnectionSuccess(response.data, requestType));
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            dispatch(checkBridgeConnectionFailure(errorMessage, requestType));
        }
    };
};

//Update Frequency Qty
export const updateFrequencyQtyRequest = (requestType) => ({
    type: UPDATE_FREQUENCY_QTY_REQUEST,
    payload: { requestType },
});

export const updateFrequencyQtySuccess = (data, requestType) => ({
    type: UPDATE_FREQUENCY_QTY_SUCCESS,
    payload: { data, requestType },
});

export const updateFrequencyQtyFailure = (error, requestType) => ({
    type: UPDATE_FREQUENCY_QTY_FAILURE,
    payload: { error, requestType },
});

export const handleUpdateFrequencyQty = ({ requestType,
    payload,
    setHasChangingDoseData,
    setIsChanging,
    setFrequencyRows,
    setFrequency,
    setDoseInputs,
    type,
    setChangingUpdateType,
    onSuccess
}) => {
    return async (dispatch) => {
        try {
            if (type !== 'update_frequency_qty') {
                dispatch(updateFrequencyQtyRequest(requestType));
            }
            const response = await Axios.post(update_frequency_qty, payload);
            if (response.status === 200) {
                dispatch(updateFrequencyQtySuccess(response.data, requestType));
                setHasChangingDoseData(true)
                handleGetChangingDoseData({
                    patientDetails: response?.data,
                    setIsChanging,
                    setFrequencyRows,
                    setFrequency,
                    setDoseInputs,
                    setHasChangingDoseData,
                    setChangingUpdateType
                })
                if (typeof onSuccess === 'function') {
                    onSuccess(response.data)
                }
                if (type !== 'remove_toast') {
                    safeToast.success('Changed dose updated successfully')
                }
                return response.data
            }
        } catch (error) {
            const message = error?.response?.data?.message || error?.response?.data?.error?.message || 'An error occurred while updating changed dose';
            safeToast.error(message)
            const errorMessage = error?.response?.data || 'An error occurred';
            dispatch(updateFrequencyQtyFailure(errorMessage, requestType));
        }
    };
};

export const handleUpdateIvCode = ({ id, iv_code }) => {
    return async () => {
        try {
            const response = await Axios.post(update_iv_code, { id, iv_code: iv_code ?? null });
            if (response?.status === 200 && response?.data?.success) {
                safeToast.success(response?.data?.message || 'IV code updated successfully.');
            }
        } catch (error) {
            const message = error?.response?.data?.message || 'Failed to update IV code.';
            safeToast.error(message);
        }
    };
};

export const handleUpdateDoseCode = ({ id, dose_code }) => {
    return async () => {
        try {
            const response = await Axios.post(update_dose_code, { id, dose_code: dose_code ?? null });
            if (response?.status === 200 && response?.data?.success) {
                safeToast.success(response?.data?.message || 'Witness/Carry updated successfully.');
            }
        } catch (error) {
            const message = error?.response?.data?.data?.dose_code?.[0] || error?.response?.data?.message || 'Failed to update Witness/Carry.';
            safeToast.error(message);
        }
    };
};

//Get Patient Rx History
export const patientRxHistoryRequest = (requestType) => ({
    type: PATIENT_RX_HISTORY_REQUEST,
    payload: { requestType },
});

export const patientRxHistorySuccess = (data, requestType) => ({
    type: PATIENT_RX_HISTORY_SUCCESS,
    payload: { data, requestType },
});

export const patientRxHistoryFailure = (error, requestType) => ({
    type: PATIENT_RX_HISTORY_FAILURE,
    payload: { error, requestType },
});

export const handleGetPatientRxHistory = ({ requestType, rx }) => {
    return async (dispatch) => {
        try {
            dispatch(patientRxHistoryRequest(requestType));
            const params = { rx_number: rx };
            const response = await Axios.get(patient_rx_history, { params });
            if (response.status === 200) {
                dispatch(patientRxHistorySuccess(response.data, requestType));
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            dispatch(patientRxHistoryFailure(errorMessage, requestType));
        }
    };
};


export const handleUpdateScheduleQuantity = ({ payload }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post('update-scheduled-quantity', payload);
            if (response.status === 200) {
                safeToast.success('Updated Successfully')
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'An error occurred while updating please try again.';
            safeToast.error(errorMessage)
        }
    };
};

export const handleDeleteInvestigateRxFrequency = ({ payload }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post('delete-investigate-rx-frequency', payload);
            if (response.status === 200) {
                // safeToast.success('Removed Successfully')
            }
        } catch (error) {
            // const errorMessage = error?.response?.data?.message || 'An error occurred while removing please try again.';
            // safeToast.error(errorMessage)
        }
    };
};

// ✅ Update Billing Frequency
let updateBillingFrequencyAbortControllers = []
export const handleUpdateBillingFrequency = ({ payload, type }) => {
    return async (dispatch) => {
        try {
            // ✅ Cancel ALL previous requests before new one starts
            updateBillingFrequencyAbortControllers.forEach(controller => controller.abort());
            updateBillingFrequencyAbortControllers = []; // Clear the array
            // 🆕 Create new controller
            const controller = new AbortController();
            updateBillingFrequencyAbortControllers.push(controller);
            const response = await Axios.post('/update-prescription-billing-frequency', payload, { signal: controller.signal });
            if (response.status === 200) {
                if (type !== 'remove_toast') {
                    safeToast.success('Billing FQY updated successfully')
                }
            }
        } catch (error) {
            if (error.name === 'CanceledError' || error.name === 'AbortError') {
                return;
            }
            const errorMessage = error?.response?.data?.message || 'An error occurred while updating Billing FQY.';
            safeToast.error(errorMessage)
        }
    };
};

// ✅ Update Billing Frequency
let updateFentanylQtyAbortControllers = []
export const handleUpdateFentanylQty = ({ payload }) => {
    return async (dispatch) => {
        try {
            // ✅ Cancel ALL previous requests before new one starts
            updateFentanylQtyAbortControllers.forEach(controller => controller.abort());
            updateFentanylQtyAbortControllers = []; // Clear the array
            // 🆕 Create new controller
            const controller = new AbortController();
            updateFentanylQtyAbortControllers.push(controller);
            const response = await Axios.post('/pharmacy-update-rx-daily-dose', payload, { signal: controller.signal });
            if (response.status === 200) {
                safeToast.success('QTY updated successfully')
            }
        } catch (error) {
            if (error.name === 'CanceledError' || error.name === 'AbortError') {
                return;
            }
            const errorMessage = error?.response?.data?.message || 'An error occurred while updating Fentanyl QTY.';
            safeToast.error(errorMessage)
        }
    };
};

export const GetScheduleQuantity = ({ rx, setUpdatedScheduleDose, setDispenseInfo }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.get(`get-scheduled-quantity?rx=${rx}`);
            if (response.status === 200) {
                setUpdatedScheduleDose(response?.data?.qty)
                setDispenseInfo(response?.data?.dispense_info)
            }
        } catch (error) {
            setUpdatedScheduleDose('')
            setDispenseInfo(null)
        }
    };
};


// ✅ Update Schedule Days
export const HandleUpdateSchedule = ({ payload, showToaster }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post('pharmacy-update-rx-sc-days', payload);
            if (response.status === 200) {
                if (showToaster) {
                    safeToast.success('Schedule days updated successfully')
                }
                return
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'An error occurred while updating schedule days.';
            safeToast.error(errorMessage)
        }
    };
};

//Emergency PDF
export const downloadEmergencyPDF = ({ date, endDate, setEmergencyPDF }) => {
    return async (dispatch) => {
        try {
            setEmergencyPDF(true)
            const isDateRange = endDate && endDate !== date
            const response = await Axios.get(`/investigate-emergency-pdf?date=${date}${isDateRange ? `&date_to=${endDate}` : ''}`,
                {
                    responseType: 'blob' // Add this to handle binary data
                }
            );

            if (response.status === 200 && response.data) {
                // Create a blob from the response data
                const blob = new Blob([response.data], { type: 'application/zip' });

                // Create object URL for the blob
                const url = window.URL.createObjectURL(blob);

                // Create temporary link element
                const link = document.createElement('a');
                link.href = url;
                link.download = `Emergency-PDF-${date}${isDateRange ? `-to-${endDate}` : ''}.zip`;

                // Trigger download
                document.body.appendChild(link);
                link.click();

                // Cleanup
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'An error occurred while downloading emergency PDF.';
            safeToast.error(errorMessage)
        } finally {
            setEmergencyPDF(false)
        }
    };
};

//Upload AI Dates
export const updateAIDatesRequest = (requestType) => ({
    type: UPDATE_AIDATES_REQUEST,
    payload: { requestType },
});

export const updateAIDatesSuccess = (data, requestType) => ({
    type: UPDATE_AIDATES_SUCCESS,
    payload: { data, requestType },
});

export const updateAIDatesFailure = (error, requestType) => ({
    type: UPDATE_AIDATES_FAILURE,
    payload: { error, requestType },
});




let updateAIDatesAbortControllers = []
export const handleUpdateAIDates = ({ requestType, payload, type }) => {

    return async (dispatch) => {

        // ✅ Cancel ALL previous requests before new one starts
        updateAIDatesAbortControllers.forEach(controller => controller.abort());
        updateAIDatesAbortControllers = []; // Clear the array
        // 🆕 Create new controller
        const controller = new AbortController();
        updateAIDatesAbortControllers.push(controller);

        try {
            if (type !== 'auto_update') {
                dispatch(updateAIDatesRequest(requestType));
            }
            const response = await Axios.post(save_ai_dates, payload, { signal: controller.signal });
            if (response.status === 200) {
                dispatch(updateAIDatesSuccess(response?.data, requestType));
                return true;
            } else {
                throw new Error('Unexpected response status');
            }
        } catch (error) {
            if (error.name === 'CanceledError' || error.name === 'AbortError') {
                return false;
            }
            dispatch(updateAIDatesFailure(error, requestType));
            return false;
        }
    };
};



export const getRxStockRequest = (requestType) => ({
    type: PHARMACY_GET_RX_STOCK_REQUEST,
    payload: { requestType },
});

export const getRxStockSuccess = (data, requestType) => ({
    type: PHARMACY_GET_RX_STOCK_SUCCESS,
    payload: { data, requestType },
});

export const getRxStockFailure = (error, requestType) => ({
    type: PHARMACY_GET_RX_STOCK_FAILURE,
    payload: { error, requestType },
});

export const getRxDeletedStatusRequest = (requestType) => ({
    type: PHARMACY_RX_DELETED_STATUS_REQUEST,
    payload: { requestType },
});

export const getRxDeletedStatusSuccess = (data, requestType) => ({
    type: PHARMACY_RX_DELETED_STATUS_SUCCESS,
    payload: { data, requestType },
});

export const getRxDeletedStatusFailure = (error, requestType) => ({
    type: PHARMACY_RX_DELETED_STATUS_FAILURE,
    payload: { error, requestType },
});


export const handleGetRxStock = ({ requestType, rxnumber }) => {
    return async (dispatch) => {
        try {
            dispatch(getRxStockRequest(requestType));
            const response = await Axios.get(get_rx_stock, { params: { rxnumber } });
            if (response.status === 200) {
                dispatch(getRxStockSuccess(response.data, requestType));
            }
        } catch (error) {
            dispatch(getRxStockFailure(error, requestType));
        }
    }
}

export const handleGetRxDeletedStatus = ({ requestType, rxnumber }) => {
    return async (dispatch) => {
        try {
            dispatch(getRxDeletedStatusRequest(requestType));
            const response = await Axios.post(pharmacy_rx_deleted_status, { rxnumber });
            if (response.status === 200) {
                dispatch(getRxDeletedStatusSuccess(response.data, requestType));
            }
        } catch (error) {
            dispatch(getRxDeletedStatusFailure(error?.response?.data || error, requestType));
        }
    }
}

export const rxDayWiseDosesRequest = (requestType) => ({
    type: RX_DAY_WISE_DOSES_REQUEST,
    payload: { requestType },
});

export const rxDayWiseDosesSuccess = (data, requestType) => ({
    type: RX_DAY_WISE_DOSES_SUCCESS,
    payload: { data, requestType },
});

export const rxDayWiseDosesFailure = (error, requestType) => ({
    type: RX_DAY_WISE_DOSES_FAILURE,
    payload: { error, requestType },
});

export const handleGetRxDayWiseDoses = ({ requestType, rx_number }) => {
    return async (dispatch) => {
        try {
            dispatch(rxDayWiseDosesRequest(requestType));
            const response = await Axios.get(get_pharmacy_rx_day_wise_doses, { params: { rx_number } });
            if (response.status === 200) {
                dispatch(rxDayWiseDosesSuccess(response.data, requestType));
            }
        } catch (error) {
            dispatch(rxDayWiseDosesFailure(error, requestType));
        }
    }
}

export const handleGetInvestigateDinGroupDrugs = ({ din }) => {
    return async () => {
        const response = await Axios.get(investigate_din_group_drugs, { params: { din } });
        return response.data;
    }
}

export const handleGetInvestigateDinChangeNotice = ({ rxnumber }) => {
    return async () => {
        const response = await Axios.get(investigate_din_change_notice, { params: { rxnumber } });
        return response.data;
    }
}

export const handleUpdateSingleDispenseRxStatus = ({ payload }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post(accountability_singleDispenseRxStatusUpdate, payload);
            if (response.status === 200) {
                if (payload.status === 1) {
                    safeToast.success('Status updated successfully')
                }
            }
        } catch (error) {
            safeToast.error('An error occurred while updating Status')
        }
    }
}

export const handleUpdateIsScCarryDose = ({ payload }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post(accountability_isScCarryDoseUpdate, payload);
            if (response.status === 200) {
                safeToast.success('Status updated successfully')
            }
        } catch (error) {
            safeToast.error('An error occurred while updating status')
        }
    }
}

export const handleUpdateDoNotBill = ({ payload }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post(update_do_not_bill, payload);
            if (response.status === 200) {
                safeToast.success('Updated successfully')
            }
        } catch (error) {
            safeToast.error('An error occurred while updating status')
        }
    }
}

//Sync RX
export const syncRxRequest = (requestType) => ({
    type: SYNC_RX_REQUEST,
    payload: { requestType },
});

export const syncRxSuccess = (data, requestType) => ({
    type: SYNC_RX_SUCCESS,
    payload: { data, requestType },
});

export const syncRxFailure = (error, requestType) => ({
    type: SYNC_RX_FAILURE,
    payload: { error, requestType },
});


export const handleSyncRx = ({ requestType, rx_number, setRefreshKey }) => {
    return async (dispatch) => {
        try {
            dispatch(syncRxRequest(requestType));
            const response = await Axios.post(sync_rx, { rx_number });
            if (response.status === 200) {
                dispatch(syncRxSuccess(response.data, requestType));
                setRefreshKey(prev => prev + 1)
            }
        } catch (error) {
            dispatch(syncRxFailure(error, requestType));
        }
    }
}

export const mapDrugRxNumberRequest = () => ({ type: MAP_DRUG_RX_NUMBER_REQUEST });
export const mapDrugRxNumberSuccess = (data) => ({ type: MAP_DRUG_RX_NUMBER_SUCCESS, payload: { data } });
export const mapDrugRxNumberFailure = (error) => ({ type: MAP_DRUG_RX_NUMBER_FAILURE, payload: { error } });

export const handleMapDrugRxNumber = ({ rx_number, setRefreshKey }) => {
    return async (dispatch) => {
        try {
            dispatch(mapDrugRxNumberRequest());
            const response = await Axios.post(map_drug_rx_number, { rx_number: rx_number });
            if (response?.data?.success !== false && response.status === 200) {
                dispatch(mapDrugRxNumberSuccess(response.data));
                dispatch(winrxMappingDataSuccess(response.data, 'winrx_mapping_data'));
                console.log('response', response.data)
                // if (typeof setRefreshKey === 'function') setRefreshKey(prev => prev + 1);
            } else {
                dispatch(mapDrugRxNumberFailure(response?.data?.message || 'Request failed'));
            }
        } catch (error) {
            const errMsg = error?.response?.data?.message || error?.message || 'Failed to map drug RX number';
            safeToast.error(errMsg)
            dispatch(mapDrugRxNumberFailure(errMsg));
        }
    };
};

export const readSigRequest = (requestType) => ({
    type: READ_SIG_REQUEST,
    payload: { requestType },
});

export const readSigSuccess = (data, requestType) => ({
    type: READ_SIG_SUCCESS,
    payload: { data, requestType },
});

export const readSigFailure = (error, requestType) => ({
    type: READ_SIG_FAILURE,
    payload: { error, requestType },
});

export const handleReadSig = ({ requestType, sig, rxnumber }) => {
    return async (dispatch) => {
        try {
            dispatch(readSigRequest(requestType));
            const response = await Axios.post('/parse-sig', { sig, rxnumber });
            dispatch(readSigSuccess(response.data, requestType));
        } catch (error) {
            const err = error?.response?.data?.error || error.message || 'Failed to parse SIG';
            showToast("Error while parsing SIG. Please try again.", "error")
            dispatch(readSigFailure(err, requestType));
        }
    }
}

export const handleGetCarryWitnessDosage = ({ requestType, rx_number }) => {
    return async (dispatch) => {
        try {
            dispatch(readSigRequest(requestType));
            const response = await Axios.get('/cycle-based-rx-witness', { params: { rx_number } });
            dispatch(readSigSuccess(response.data, requestType));
        } catch (error) {
            const err = error?.response?.data?.error || error.message || 'Failed to get carry witness dosage';
            dispatch(readSigFailure(err, requestType));
        }
    }
}

const postWitnessCarryCycleRequest = (key) => ({
    type: POST_WITNESS_CARRY_CYCLE_REQUEST,
    payload: { key },
});

const postWitnessCarryCycleSuccess = (key, data) => ({
    type: POST_WITNESS_CARRY_CYCLE_SUCCESS,
    payload: { key, data },
});

const postWitnessCarryCycleFailure = (key, error) => ({
    type: POST_WITNESS_CARRY_CYCLE_FAILURE,
    payload: { key, error },
});

const deleteWitnessCarryCycleRequest = (key) => ({
    type: DELETE_WITNESS_CARRY_CYCLE_REQUEST,
    payload: { key },
});

const deleteWitnessCarryCycleSuccess = (key) => ({
    type: DELETE_WITNESS_CARRY_CYCLE_SUCCESS,
    payload: { key },
});

const deleteWitnessCarryCycleFailure = (key, error) => ({
    type: DELETE_WITNESS_CARRY_CYCLE_FAILURE,
    payload: { key, error },
});

export const postWitnessCarryCycle = ({ payload, id, cycle_no }) => {
    return async (dispatch) => {
        const key = id ?? cycle_no;
        try {
            dispatch(postWitnessCarryCycleRequest(key));
            const response = await Axios.post('/cycle-based-rx-witness', payload);
            const data = response?.data?.data || response?.data;
            dispatch(postWitnessCarryCycleSuccess(key, data));
            return data;
        } catch (error) {
            const err = error?.response?.data?.error || error.message || 'Failed to save witness carry cycle';
            dispatch(postWitnessCarryCycleFailure(key, err));
            throw new Error(err);
        }
    };
};

export const deleteWitnessCarryCycle = ({ id, rx_number }) => {
    return async (dispatch) => {
        const key = id;
        try {
            dispatch(deleteWitnessCarryCycleRequest(key));
            await Axios.delete('/cycle-based-rx-witness', { data: { cycle_no: id, rx_number } });
            dispatch(deleteWitnessCarryCycleSuccess(key));
            return { id };
        } catch (error) {
            const err = error?.response?.data?.error || error.message || 'Failed to delete witness carry cycle';
            dispatch(deleteWitnessCarryCycleFailure(key, err));
            throw new Error(err);
        }
    };
};

export const lastSevenRDeliveryRequest = () => ({
    type: LAST_SEVEN_RDELIVERY_REQUEST,
});

export const lastSevenRDeliverySuccess = (data) => ({
    type: LAST_SEVEN_RDELIVERY_SUCCESS,
    payload: data,
});

export const lastSevenRDeliveryFailure = (error) => ({
    type: LAST_SEVEN_RDELIVERY_FAILURE,
    payload: error,
});

// export const fetchLastSevenRDelivery = (rxnum = '498328') => {
//     return async (dispatch) => {
//         dispatch(lastSevenRDeliveryRequest());
//         try {
//             const params = { rxnum };
//             const response = await Axios.get(get_last_seven_rdelivery, { params });
//             if (response.status === 200) {
//                 const list = response?.data?.data || [];
//                 dispatch(lastSevenRDeliverySuccess(list));
//             } else {
//                 throw new Error('Unexpected response status');
//             }
//         } catch (error) {
//             const errorMessage = error?.response?.data?.message || 'An error occurred';
//             dispatch(lastSevenRDeliveryFailure(errorMessage));
//         }
//     };
// };

export const fetchLastSevenRDelivery = (route, rxnumber, type) => {
    return async (dispatch) => {
        dispatch(lastSevenRDeliveryRequest());
        try {
            const params = { route, rxnumber, type };
            const response = await Axios.get('get-route-patient-zipcode', { params });
            if (response.status === 200) {
                const list = response?.data?.data || [];
                dispatch(lastSevenRDeliverySuccess(list));
            } else {
                throw new Error('Unexpected response status');
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'An error occurred';
            dispatch(lastSevenRDeliveryFailure(errorMessage));
        }
    };
};

export const getPatientDocumentListRequest = (requestType) => ({
    type: GET_PATIENT_DOCUMENT_LIST_REQUEST,
    payload: { requestType },
});

export const getPatientDocumentListSuccess = (data, requestType) => ({
    type: GET_PATIENT_DOCUMENT_LIST_SUCCESS,
    payload: { data, requestType },
});

export const getPatientDocumentListFailure = (error, requestType) => ({
    type: GET_PATIENT_DOCUMENT_LIST_FAILURE,
    payload: { error, requestType },
});





//Get Patient Investigation List
export const getPatientDocumentList = ({ requestType, params }) => {
    return async (dispatch) => {
        dispatch(getPatientDocumentListRequest(requestType));
        try {
            const response = await Axios.get(get_patient_document_list, { params });
            if (response.status === 200) {
                dispatch(getPatientDocumentListSuccess(response.data, requestType));
            }
        } catch (error) {
            dispatch(getPatientDocumentListFailure(error, requestType));
        }
    }
}


// Check Rxnumber Dilaudid
export const checkRxnumberDilaudidRequest = (requestType) => ({
    type: CHECK_RXNUMBER_DILAUDID_REQUEST,
    payload: { requestType },
});

export const checkRxnumberDilaudidSuccess = (data, requestType) => ({
    type: CHECK_RXNUMBER_DILAUDID_SUCCESS,
    payload: { data, requestType },
});

export const checkRxnumberDilaudidFailure = (error, requestType) => ({
    type: CHECK_RXNUMBER_DILAUDID_FAILURE,
    payload: { error, requestType },
});

export const handleCheckRxnumberDilaudid = ({ requestType, rxnumber }) => {
    return async (dispatch) => {
        dispatch(checkRxnumberDilaudidRequest(requestType));
        try {
            const response = await Axios.get(check_rxnumber_dilaudid, { params: { rxnumber } });
            if (response.status === 200) {
                dispatch(checkRxnumberDilaudidSuccess(response.data, requestType));
            }
        } catch (error) {
            dispatch(checkRxnumberDilaudidFailure(error, requestType));
        }
    }
}

//Mark Refill Flexi
export const markRefillFlexiRequest = (requestType) => ({
    type: MARK_REFILL_FLEXI_REQUEST,
    payload: { requestType },
});

export const markRefillFlexiSuccess = (data, requestType) => ({
    type: MARK_REFILL_FLEXI_SUCCESS,
    payload: { data, requestType },
});

export const markRefillFlexiFailure = (error, requestType) => ({
    type: MARK_REFILL_FLEXI_FAILURE,
    payload: { error, requestType },
});

export const handleMarkRefillFlexi = ({ requestType, payload, rethrowError = false }) => {
    return async (dispatch) => {
        try {
            dispatch(markRefillFlexiRequest(requestType));
            const response = await Axios.post(accountability_markRefillFlexi, payload);
            if (response.status === 200) {
                dispatch(markRefillFlexiSuccess(response.data, requestType));
            }
            return response.data;
        } catch (error) {
            dispatch(markRefillFlexiFailure(error, requestType));
            if (rethrowError) throw error;
            safeToast.error('Oops! Something went wrong')
        }
    }
}


//Update Rephrase Notes
export const updateRephraseNotesRequest = (requestType) => ({
    type: UPDATE_REPHRASE_NOTES_REQUEST,
    payload: { requestType },
});

export const updateRephraseNotesSuccess = (data, requestType) => ({
    type: UPDATE_REPHRASE_NOTES_SUCCESS,
    payload: { data, requestType },
});

export const updateRephraseNotesFailure = (error, requestType) => ({
    type: UPDATE_REPHRASE_NOTES_FAILURE,
    payload: { error, requestType },
});

export const handleUpdateRephraseNotes = ({ reqData,
    requestType,
    setPatientNotes,
    rxNumber,
    setFormData
}) => {
    return async (dispatch) => {
        try {
            dispatch(updateRephraseNotesRequest(requestType));
            const response = await Axios.post(`${med_rephrase_drp}`, reqData);
            if (response.status === 200) {
                dispatch(updateRephraseNotesSuccess(response.data, requestType))
                const rephrasedText = response?.data?.data?.rephrased_text
                if (requestType === 'template-rephrase') {
                    setFormData((prev) => ({
                        ...prev,
                        template: rephrasedText
                    }))
                } else {
                    // Append prescription number to the rephrased text if it exists
                    const finalText = rxNumber ? `${rxNumber} ${rephrasedText}` : rephrasedText
                    setPatientNotes(finalText)
                }
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            dispatch(updateRephraseNotesFailure(errorMessage, requestType));
            showToast("Error while rephrasing Notes. Please try again.", "error")
        }
    };
};


export const handleUpdateTemplateNotes = ({ reqData,
    requestType,
    setTemplateName,
}) => {
    return async (dispatch) => {
        try {
            dispatch(updateRephraseNotesRequest(requestType));
            const response = await Axios.post(`${med_rephrase_drp}`, reqData);
            if (response.status === 200) {
                dispatch(updateRephraseNotesSuccess(response.data, requestType))
                const rephrasedText = response?.data?.data?.rephrased_text
                setTemplateName(rephrasedText)
            }
        } catch (error) {
            const errorMessage = error?.response?.data || 'An error occurred';
            dispatch(updateRephraseNotesFailure(errorMessage, requestType));
            showToast("Error while rephrasing Template Notes. Please try again.", "error")
        }
    };
};

// Update Schedule Dose
export const handleUpdateScheduleDose = ({ payload, setUpdatedScheduleDose, setDispenseInfo }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post(save_schedule_dose, payload);
            if (response.status === 200) {
                safeToast.success('Schedule dose updated successfully');

                // Update the state directly with the new value
                if (setUpdatedScheduleDose) {
                    setUpdatedScheduleDose(payload.quantity);
                }

                // Refresh the schedule dose data to update the UI
                // if (setUpdatedScheduleDose && setDispenseInfo) {
                //     dispatch(GetScheduleQuantity({
                //         rx: payload.rx,
                //         setUpdatedScheduleDose,
                //         setDispenseInfo
                //     }));
                // }
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'An error occurred while updating schedule dose.';
            safeToast.error(errorMessage);
        }
    };
};

export const handleUpdatePrescriptionQuantity = ({ payload, onSuccess }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post(update_prescription_quantity, payload);
            if (response.status === 200) {
                const updatedQty = response?.data?.data?.quantity_authorized;
                if (updatedQty !== undefined && updatedQty !== null) {
                    dispatch(updatePrescriptionQuantityLocal(updatedQty));
                }
                safeToast.success('Prescription quantity updated successfully');
                if (typeof onSuccess === 'function') {
                    onSuccess(response.data);
                }
                return response.data;
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message
                || error?.response?.data?.data?.error
                || 'An error occurred while updating prescription quantity.';
            safeToast.error(
                typeof errorMessage === 'string'
                    ? errorMessage
                    : 'An error occurred while updating prescription quantity.'
            );
            throw error;
        }
    };
};

// Save RX Stop Date (uses absolute URL as per spec)
export const handleSaveRxStopDate = ({ payload, onSuccess, onError }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post('save-rxstop-date', payload);
            if (response.status === 200 && response?.data?.success === true) {
                const message = response?.data?.message || 'RX stop date saved successfully.';
                showToast(message, 'success');
                if (onSuccess) onSuccess(response.data);
            } else {
                const errorMessage = response?.data?.message || 'Failed to save RX stop date.';
                showToast(errorMessage, 'error');
                if (onError) onError(new Error(errorMessage));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || 'Failed to save RX stop date.';
            showToast(errorMessage, 'error');
            if (onError) onError(error);
        }
    };
};

// Save RX Written Date
export const handleSaveRxWrittenDate = ({ payload, onSuccess, onError }) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post('update-written-date', payload);
            if (response.status === 200 && response?.data?.success === true) {
                const message = response?.data?.message || 'Written date updated successfully.';
                showToast(message, 'success');
                if (onSuccess) onSuccess(response.data);
            } else {
                const errorMessage = response?.data?.message || 'Failed to update written date.';
                showToast(errorMessage, 'error');
                if (onError) onError(new Error(errorMessage));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update written date.';
            showToast(errorMessage, 'error');
            if (onError) onError(error);
        }
    };
};

// Update Multiple PDF Template Action Creators
export const updateMultiplePdfTemplateRequest = (requestType) => ({
    type: UPDATE_MULTIPLE_PDF_TEMPLATE_REQUEST,
    payload: { requestType },
});

export const updateMultiplePdfTemplateSuccess = (data, requestType) => ({
    type: UPDATE_MULTIPLE_PDF_TEMPLATE_SUCCESS,
    payload: { data, requestType },
});

export const updateMultiplePdfTemplateFailure = (error, requestType) => ({
    type: UPDATE_MULTIPLE_PDF_TEMPLATE_FAILURE,
    payload: { error, requestType },
});

const refreshInvestigationRxList = ({ dispatch, formData, fetchType, setLoading }) => {
    setLoading(true)
    dispatch(fetchPatientInvestigateRxList({ formData, requestType: fetchType })).then(() => {
        setLoading(false)
    })
}

export const handleUpdateMultiplePdfTemplate = ({ requestData, requestType, setAssignModalOpen, setSelectedPrescriptions, formData, fetchType, setLoading, setEmergencyTemplatePreview }) => {
    return async (dispatch) => {
        dispatch(updateMultiplePdfTemplateRequest(requestType));

        try {
            const previewResponse = await Axios.post(pharmacy_preview_winrx_emergency_template_pdf, requestData);

            const previewPayload = previewResponse?.data?.data || {};
            const previewResults = Array.isArray(previewPayload?.results) ? previewPayload.results : [];
            const previewItems = previewResults.filter((item) => item?.requires_confirmation && item?.preview_pdf);
            const blockingError = previewResults.find((item) => item?.pdf_status === 'already_sent' || item?.error);

            if (previewPayload?.requires_confirmation && previewItems.length > 0) {
                dispatch(updateMultiplePdfTemplateSuccess(previewPayload, requestType));
                if (typeof setEmergencyTemplatePreview === 'function') {
                    setEmergencyTemplatePreview({
                        open: true,
                        requestData,
                        previews: previewItems,
                    });
                }
                return;
            }

            if (blockingError?.error && previewResults.every((item) => item?.pdf_status !== 'legacy_flow')) {
                throw new Error(blockingError.error);
            }

            const response = await Axios.post(pharmacy_save_multiple_pdf_template_data, requestData);

            if (response.status === 200) {
                dispatch(updateMultiplePdfTemplateSuccess(response.data, requestType));
                showToast('PDF templates updated successfully!', 'success');
                setAssignModalOpen(false);
                setSelectedPrescriptions({})
                refreshInvestigationRxList({ dispatch, formData, fetchType, setLoading })
            } else {
                throw new Error('Unexpected response status');
            }

        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while updating PDF templates';
            dispatch(updateMultiplePdfTemplateFailure(errorMessage, requestType));
            showToast(errorMessage, 'error');
        }
    };
};

export const confirmWinRxEmergencyTemplatePdf = ({ requestData, requestType, setAssignModalOpen, setSelectedPrescriptions, setEmergencyTemplatePreview, formData, fetchType, setLoading }) => {
    return async (dispatch) => {
        dispatch(updateMultiplePdfTemplateRequest(requestType));

        try {
            const response = await Axios.post(pharmacy_submit_winrx_emergency_template_pdf, requestData);

            if (response.status === 200) {
                dispatch(updateMultiplePdfTemplateSuccess(response.data, requestType));
                showToast('PDF templates updated successfully!', 'success');
                setAssignModalOpen(false);
                setSelectedPrescriptions({});
                if (typeof setEmergencyTemplatePreview === 'function') {
                    setEmergencyTemplatePreview({ open: false, requestData: null, previews: [] });
                }
                refreshInvestigationRxList({ dispatch, formData, fetchType, setLoading });
            } else {
                throw new Error('Unexpected response status');
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while updating PDF templates';
            dispatch(updateMultiplePdfTemplateFailure(errorMessage, requestType));
            showToast(errorMessage, 'error');
        }
    };
};

// Initial State
const initialState = {
    // data: null,
    data: {
        data: [],
        pagination: {},
    },

    loading: false,
    error: null,
    requestType: null,

    innvestigateSynxRx: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    investigateRxMetrics: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    investigateRxMetricDetails: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    patientPrescriptionDetails: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    dr_sign_verfication: {
        data: null,
        requestType: null
    },

    investigatePage: {
        data: null,
        requestType: null
    },

    investigationPDFData: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    rxSignaturesRequestedData: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    checkBridgeConnection: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    updateFrequencyQty: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    patientRxHistory: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    patientRxViewDocuments: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    sigAI: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    readSig: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    witnessCarryCycles: {
        pending: {},
        error: {},
    },

    updateAIDates: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },
    pharmacyGetRxStock: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },
    rxDayWiseDoses: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },
    syncRx: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },
    mapDrugRxNumber: {
        data: null,
        loading: false,
        error: null
    },
    patientDocumentList: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },
    checkRxnumberDilaudid: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },
    markRefillFlexi: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },

    updateRephraseNotes: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },
    updateMultiplePdfTemplate: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },
    lastSevenDeliveries: {
        list: [],
        status: 'idle',
        error: null,
    },
    investigationAiSetting: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },
    winrxMappingData: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    },
    rxDeletedStatus: {
        data: null,
        loading: false,
        error: null,
        requestType: null
    }
};

// Reducer
const investigateRxListReducer = (state = initialState, action) => {
    switch (action.type) {
        // Today's Investigation list
        case PHARMACY_INVESTIGATE_RX_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                requestType: action.payload.requestType,
                // data: null
            };
        case PHARMACY_INVESTIGATE_RX_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    data: [
                        ...state.data.data,
                        ...action?.payload?.data?.data?.data.filter(
                            (newItem) => !state.data.data.some((existingItem) => existingItem.id === newItem.id)
                        ),
                    ],
                    template_data: action.payload?.data?.data?.narcotic_template,
                    non_narcotic_template: action.payload?.data?.data?.non_narcotic_template,
                    pagination: action.payload?.data?.data?.pagination,
                },

                error: null,
                requestType: action.payload.requestType,
            };
        case PHARMACY_INVESTIGATE_RX_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: null,
                requestType: action.payload.requestType,
            };

        // Investigation Analytics tiles
        case INVESTIGATE_RX_METRICS_REQUEST:
            return {
                ...state,
                investigateRxMetrics: {
                    // Keep the previous numbers on screen while the next range loads so the
                    // tiles do not flash empty on every date change.
                    ...state.investigateRxMetrics,
                    loading: true,
                    error: null,
                    requestType: action.payload.requestType,
                },
            };
        case INVESTIGATE_RX_METRICS_SUCCESS:
            return {
                ...state,
                investigateRxMetrics: {
                    data: action.payload?.data?.data ?? null,
                    loading: false,
                    error: null,
                    requestType: action.payload.requestType,
                },
            };
        case INVESTIGATE_RX_METRICS_FAILURE:
            return {
                ...state,
                investigateRxMetrics: {
                    data: null,
                    loading: false,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                },
            };

        // Investigation Analytics details table
        case INVESTIGATE_RX_METRIC_DETAILS_REQUEST:
            return {
                ...state,
                investigateRxMetricDetails: {
                    // Same reasoning as the tiles: hold the current rows while the next page or
                    // status filter loads, so the table does not blank out on every click.
                    ...state.investigateRxMetricDetails,
                    loading: true,
                    error: null,
                    requestType: action.payload.requestType,
                },
            };
        case INVESTIGATE_RX_METRIC_DETAILS_SUCCESS:
            return {
                ...state,
                investigateRxMetricDetails: {
                    data: action.payload?.data?.data ?? null,
                    loading: false,
                    error: null,
                    requestType: action.payload.requestType,
                },
            };
        case INVESTIGATE_RX_METRIC_DETAILS_FAILURE:
            return {
                ...state,
                investigateRxMetricDetails: {
                    data: null,
                    loading: false,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                },
            };

        case CLEAR_INVESTIGATE_RX_DATA:
            return {
                ...state,
                data: {
                    data: [], // Clear the data array
                    pagination: {}, // Reset pagination
                },
                error: null,
                loading: false,
            };

        //Sync RX
        case INVESTIGATE_SYNC_RX_REQUEST:
            return {
                ...state,
                innvestigateSynxRx: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case INVESTIGATE_SYNC_RX_SUCCESS:
            return {
                ...state,
                innvestigateSynxRx: {
                    loading: false,
                    error: null,
                    requestType: action.payload.requestType,
                    data: action.payload.data
                }
            };
        case INVESTIGATE_SYNC_RX_FAILURE:
            return {
                ...state,
                innvestigateSynxRx: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        //Prescription Details
        case PATIENT_REVIEW_PRESCRIPTION_DETAILS_REQUEST:
            return {
                ...state,
                patientPrescriptionDetails: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case PATIENT_REVIEW_PRESCRIPTION_DETAILS_SUCCESS:
            return {
                ...state,
                patientPrescriptionDetails: {
                    loading: false,
                    error: null,
                    requestType: action.payload.requestType,
                    data: action.payload.data
                }
            };
        case PATIENT_REVIEW_PRESCRIPTION_DETAILS_FAILURE:
            return {
                ...state,
                patientPrescriptionDetails: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };
        case UPDATE_PRESCRIPTION_FREQUENCY_LOCAL: {
            const currentData = state.patientPrescriptionDetails?.data;
            const currentPatientData = currentData?.data;

            if (!currentPatientData
                || !action.payload.frequencyData
                || Number(currentPatientData.rxdata_id) !== Number(action.payload.rxesId)) {
                return state;
            }

            return {
                ...state,
                patientPrescriptionDetails: {
                    ...state.patientPrescriptionDetails,
                    data: {
                        ...currentData,
                        data: {
                            ...currentPatientData,
                            get_requency_data: action.payload.frequencyData,
                        },
                    },
                },
            };
        }
        case MARK_PRESCRIPTION_AI_CHANGING_LOCAL: {
            const currentData = state.patientPrescriptionDetails?.data;
            const currentPatientData = currentData?.data;

            if (!currentPatientData
                || Number(currentPatientData.rxdata_id) !== Number(action.payload.rxesId)) {
                return state;
            }

            const currentFrequencyData = currentPatientData.get_requency_data;

            return {
                ...state,
                patientPrescriptionDetails: {
                    ...state.patientPrescriptionDetails,
                    data: {
                        ...currentData,
                        data: {
                            ...currentPatientData,
                            is_ai_changing_dose: 1,
                            // New object so the page re-reads the schedule.
                            get_requency_data: currentFrequencyData && !Array.isArray(currentFrequencyData)
                                ? { ...currentFrequencyData }
                                : {},
                        },
                    },
                },
            };
        }
        case UPDATE_PRESCRIPTION_QUANTITY_LOCAL: {
            const currentData = state.patientPrescriptionDetails?.data;
            const currentPatientData = currentData?.data;

            if (!currentPatientData) {
                return state;
            }

            return {
                ...state,
                patientPrescriptionDetails: {
                    ...state.patientPrescriptionDetails,
                    data: {
                        ...currentData,
                        data: {
                            ...currentPatientData,
                            rxqty: action.payload.quantity,
                            prescription_detail: currentPatientData?.prescription_detail
                                ? {
                                    ...currentPatientData.prescription_detail,
                                    quantity_authorized: action.payload.quantity,
                                }
                                : currentPatientData?.prescription_detail,
                        },
                    },
                },
            };
        }
        case UPDATE_RX_STOP_DATE_LOCAL: {
            const currentData = state.patientPrescriptionDetails?.data;
            const currentPatientData = currentData?.data;
            const payload = action.payload || {};

            if (!currentPatientData) {
                return state;
            }

            return {
                ...state,
                patientPrescriptionDetails: {
                    ...state.patientPrescriptionDetails,
                    data: {
                        ...currentData,
                        data: {
                            ...currentPatientData,
                            ...(Object.prototype.hasOwnProperty.call(payload, 'ai_stop_date') && { ai_stop_date: payload.ai_stop_date }),
                            ...(Object.prototype.hasOwnProperty.call(payload, 'ai_end_date') && { ai_end_date: payload.ai_end_date }),
                            ...(Object.prototype.hasOwnProperty.call(payload, 'is_ai_stop_date_older_than_30_days') && {
                                is_ai_stop_date_older_than_30_days: payload.is_ai_stop_date_older_than_30_days,
                            }),
                            ...(Object.prototype.hasOwnProperty.call(payload, '100_days_calculated_date') && {
                                '100_days_calculated_date': payload['100_days_calculated_date'],
                            }),
                            ...(Object.prototype.hasOwnProperty.call(payload, '100_days_calculated_date_ymd') && {
                                '100_days_calculated_date_ymd': payload['100_days_calculated_date_ymd'],
                            }),
                            ...(Object.prototype.hasOwnProperty.call(payload, '100_days_difference') && {
                                '100_days_difference': payload['100_days_difference'],
                            }),
                            note_detail: {
                                ...(currentPatientData.note_detail || {}),
                                ...(payload.note_detail || {}),
                            },
                            date_range: {
                                ...(currentPatientData.date_range || {}),
                                ...(payload.date_range || {}),
                            },
                        },
                    },
                },
            };
        }
        case UPDATE_RX_WRITTEN_DATE_LOCAL: {
            const currentData = state.patientPrescriptionDetails?.data;
            const currentPatientData = currentData?.data;
            const payload = action.payload || {};
            const rxStopDate = payload.stop_date_ymd || payload.rxstop || payload['100_days_calculated_date_ymd'];
            const rxStopDisplayDate = payload.formatted_rxstop || payload.stop_date || payload?.note_detail?.stop_date;
            const calculatedDateYmd = payload['100_days_calculated_date_ymd'] || rxStopDate;
            const calculatedDateDisplay = payload.formatted_100_days_calculated_date || payload['100_days_calculated_date'];

            if (!currentPatientData) {
                return state;
            }

            return {
                ...state,
                patientPrescriptionDetails: {
                    ...state.patientPrescriptionDetails,
                    data: {
                        ...currentData,
                        data: {
                            ...currentPatientData,
                            ...(Object.prototype.hasOwnProperty.call(payload, 'written_date') && { written_date: payload.written_date }),
                            ...(Object.prototype.hasOwnProperty.call(payload, 'formatted_written_date') && {
                                formatted_written_date: payload.formatted_written_date,
                            }),
                            ...(Object.prototype.hasOwnProperty.call(payload, 'rxstop') && { rxstop: payload.rxstop }),
                            ...(Object.prototype.hasOwnProperty.call(payload, 'ai_stop_date') && { ai_stop_date: payload.ai_stop_date }),
                            ...(Object.prototype.hasOwnProperty.call(payload, 'ai_end_date') && { ai_end_date: payload.ai_end_date }),
                            ...(Object.prototype.hasOwnProperty.call(payload, 'is_ai_stop_date_older_than_30_days') && {
                                is_ai_stop_date_older_than_30_days: payload.is_ai_stop_date_older_than_30_days,
                            }),
                            ...(calculatedDateDisplay && {
                                '100_days_calculated_date': calculatedDateDisplay,
                            }),
                            ...(calculatedDateYmd && {
                                '100_days_calculated_date_ymd': calculatedDateYmd,
                            }),
                            ...(Object.prototype.hasOwnProperty.call(payload, '100_days_difference') && {
                                '100_days_difference': payload['100_days_difference'],
                            }),
                            note_detail: {
                                ...(currentPatientData.note_detail || {}),
                                ...(payload.note_detail || {}),
                                ...(rxStopDisplayDate && { stop_date: rxStopDisplayDate }),
                            },
                            date_range: {
                                ...(currentPatientData.date_range || {}),
                                ...(payload.date_range || {}),
                                ...(rxStopDate && { stop_date: rxStopDate }),
                            },
                        },
                    },
                },
            };
        }

        //Prescription Details PDF
        case RX_PRESCRIPTION_PDF_REQUEST:
            return {
                ...state,
                investigationPDFData: {
                    loading: true,
                    data: action.payload.preserveExistingData
                        ? state.investigationPDFData.data
                        : null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case RX_PRESCRIPTION_PDF_SUCCESS:
            return {
                ...state,
                investigationPDFData: {
                    loading: false,
                    error: null,
                    requestType: action.payload.requestType,
                    data: (action.payload.preserveExistingData || action.payload.data?.is_winrx_emergency_template_preview)
                        ? {
                            ...(state.investigationPDFData.data || {}),
                            ...action.payload.data,
                        }
                        : action.payload.data
                }
            };
        case RX_PRESCRIPTION_PDF_FAILURE:
            return {
                ...state,
                investigationPDFData: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        //Patient View Documents PDF
        case PATIENT_RX_VIEW_DOCUMENTS_REQUEST:
            return {
                ...state,
                patientRxViewDocuments: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case PATIENT_RX_VIEW_DOCUMENTS_SUCCESS:
            return {
                ...state,
                patientRxViewDocuments: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case PATIENT_RX_VIEW_DOCUMENTS_FAILURE:
            return {
                ...state,
                patientRxViewDocuments: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        //Prescription Details PDF
        case RX_SIGNATURES_REQUESTED_LIST_REQUEST:
            return {
                ...state,
                rxSignaturesRequestedData: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case RX_SIGNATURES_REQUESTED_LIST_SUCCESS:
            return {
                ...state,
                rxSignaturesRequestedData: {
                    loading: false,
                    error: null,
                    requestType: action.payload.requestType,
                    data: action.payload.data
                }
            };
        case RX_SIGNATURES_REQUESTED_LIST_FAILURE:
            return {
                ...state,
                rxSignaturesRequestedData: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        //Dr Sign verification
        case DR_SIGNATURE_VERIFIED_DATA:
            return {
                ...state,
                dr_sign_verfication: {
                    data: action.payload.data,
                    requestType: action.payload.requestType,
                }
            };

        //Get PDF current Page
        case INVESTIGATE_RX_PDF_CURRENT_PAGE:
            return {
                ...state,
                investigatePage: {
                    data: action.payload.data,
                    requestType: action.payload.requestType,
                }
            };

        //Check Bridge Connection
        case CHECK_BRIDGE_CONNECTION_REQUEST:
            return {
                ...state,
                checkBridgeConnection: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case CHECK_BRIDGE_CONNECTION_SUCCESS:
            return {
                ...state,
                checkBridgeConnection: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case CHECK_BRIDGE_CONNECTION_FAILURE:
            return {
                ...state,
                checkBridgeConnection: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        //Update Frequency Qty
        case UPDATE_FREQUENCY_QTY_REQUEST:
            return {
                ...state,
                updateFrequencyQty: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case UPDATE_FREQUENCY_QTY_SUCCESS:
            return {
                ...state,
                updateFrequencyQty: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case UPDATE_FREQUENCY_QTY_FAILURE:
            return {
                ...state,
                updateFrequencyQty: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        //Get Patient Rx History
        case PATIENT_RX_HISTORY_REQUEST:
            return {
                ...state,
                patientRxHistory: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case PATIENT_RX_HISTORY_SUCCESS:
            return {
                ...state,
                patientRxHistory: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case PATIENT_RX_HISTORY_FAILURE:
            return {
                ...state,
                patientRxHistory: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        case SIG_AI_REQUEST:
            return {
                ...state,
                sigAI: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case SIG_AI_SUCCESS:
            return {
                ...state,
                sigAI: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case SIG_AI_FAILURE:
            return {
                ...state,
                sigAI: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        case READ_SIG_REQUEST:
            return {
                ...state,
                readSig: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case READ_SIG_SUCCESS:
            return {
                ...state,
                readSig: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case READ_SIG_FAILURE:
            return {
                ...state,
                readSig: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        //Update AI Dates
        case UPDATE_AIDATES_REQUEST:
            return {
                ...state,
                updateAIDates: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case UPDATE_AIDATES_SUCCESS:
            return {
                ...state,
                updateAIDates: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case UPDATE_AIDATES_FAILURE:
            return {
                ...state,
                updateAIDates: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        case PHARMACY_GET_RX_STOCK_REQUEST:
            return {
                ...state,
                pharmacyGetRxStock: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case PHARMACY_GET_RX_STOCK_SUCCESS:
            return {
                ...state,
                pharmacyGetRxStock: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case PHARMACY_GET_RX_STOCK_FAILURE:
            return {
                ...state,
                pharmacyGetRxStock: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        case PHARMACY_RX_DELETED_STATUS_REQUEST:
            return {
                ...state,
                rxDeletedStatus: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case PHARMACY_RX_DELETED_STATUS_SUCCESS:
            return {
                ...state,
                rxDeletedStatus: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case PHARMACY_RX_DELETED_STATUS_FAILURE:
            return {
                ...state,
                rxDeletedStatus: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        case RX_DAY_WISE_DOSES_REQUEST:
            return {
                ...state,
                rxDayWiseDoses: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case RX_DAY_WISE_DOSES_SUCCESS:
            return {
                ...state,
                rxDayWiseDoses: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case RX_DAY_WISE_DOSES_FAILURE:
            return {
                ...state,
                rxDayWiseDoses: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        //Sync RX
        case SYNC_RX_REQUEST:
            return {
                ...state,
                syncRx: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case SYNC_RX_SUCCESS:
            return {
                ...state,
                syncRx: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case SYNC_RX_FAILURE:
            return {
                ...state,
                syncRx: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        // Map Drug RX Number (AI)
        case MAP_DRUG_RX_NUMBER_REQUEST:
            return {
                ...state,
                mapDrugRxNumber: {
                    loading: true,
                    data: null,
                    error: null,
                }
            };
        case MAP_DRUG_RX_NUMBER_SUCCESS:
            return {
                ...state,
                mapDrugRxNumber: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                }
            };
        case MAP_DRUG_RX_NUMBER_FAILURE:
            return {
                ...state,
                mapDrugRxNumber: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                }
            };

        //Get Patient Document List
        case GET_PATIENT_DOCUMENT_LIST_REQUEST:
            return {
                ...state,
                patientDocumentList: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case GET_PATIENT_DOCUMENT_LIST_SUCCESS:
            return {
                ...state,
                patientDocumentList: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case GET_PATIENT_DOCUMENT_LIST_FAILURE:
            return {
                ...state,
                patientDocumentList: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };


        //Check Rxnumber Dilaudid
        case CHECK_RXNUMBER_DILAUDID_REQUEST:
            return {
                ...state,
                checkRxnumberDilaudid: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case CHECK_RXNUMBER_DILAUDID_SUCCESS:
            return {
                ...state,
                checkRxnumberDilaudid: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case CHECK_RXNUMBER_DILAUDID_FAILURE:
            return {
                ...state,
                checkRxnumberDilaudid: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        //Mark Refill Flexi
        case MARK_REFILL_FLEXI_REQUEST:
            return {
                ...state,
                markRefillFlexi: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case MARK_REFILL_FLEXI_SUCCESS:
            return {
                ...state,
                markRefillFlexi: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case MARK_REFILL_FLEXI_FAILURE:
            return {
                ...state,
                markRefillFlexi: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        //Update Rephrase Notes
        case UPDATE_REPHRASE_NOTES_REQUEST:
            return {
                ...state,
                updateRephraseNotes: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case UPDATE_REPHRASE_NOTES_SUCCESS:
            return {
                ...state,
                updateRephraseNotes: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case UPDATE_REPHRASE_NOTES_FAILURE:
            return {
                ...state,
                updateRephraseNotes: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        //Update Multiple PDF Template
        case UPDATE_MULTIPLE_PDF_TEMPLATE_REQUEST:
            return {
                ...state,
                updateMultiplePdfTemplate: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case UPDATE_MULTIPLE_PDF_TEMPLATE_SUCCESS:
            return {
                ...state,
                updateMultiplePdfTemplate: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };

        case UPDATE_MULTIPLE_PDF_TEMPLATE_FAILURE:
            return {
                ...state,
                updateMultiplePdfTemplate: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        // WinRx Mapping Data
        case GET_WINRX_MAPPING_DATA_REQUEST:
            return {
                ...state,
                winrxMappingData: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case GET_WINRX_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                winrxMappingData: {
                    loading: false,
                    error: null,
                    data: action.payload.data,
                    requestType: action.payload.requestType,
                }
            };
        case GET_WINRX_MAPPING_DATA_FAILURE:
            return {
                ...state,
                winrxMappingData: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        case INVESTIGATION_AI_SETTING_REQUEST:
            return {
                ...state,
                investigationAiSetting: {
                    loading: true,
                    data: null,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case INVESTIGATION_AI_SETTING_SUCCESS:
            return {
                ...state,
                investigationAiSetting: {
                    loading: false,
                    data: action.payload.data,
                    error: null,
                    requestType: action.payload.requestType,
                }
            };
        case INVESTIGATION_AI_SETTING_FAILURE:
            return {
                ...state,
                investigationAiSetting: {
                    loading: false,
                    data: null,
                    error: action.payload.error,
                    requestType: action.payload.requestType,
                }
            };

        case POST_WITNESS_CARRY_CYCLE_REQUEST:
            return {
                ...state,
                witnessCarryCycles: {
                    pending: { ...state.witnessCarryCycles.pending, [action.payload.key]: true },
                    error: { ...state.witnessCarryCycles.error, [action.payload.key]: null },
                },
            };
        case POST_WITNESS_CARRY_CYCLE_SUCCESS:
            return {
                ...state,
                witnessCarryCycles: {
                    pending: { ...state.witnessCarryCycles.pending, [action.payload.key]: false },
                    error: { ...state.witnessCarryCycles.error, [action.payload.key]: null },
                },
            };
        case POST_WITNESS_CARRY_CYCLE_FAILURE:
            return {
                ...state,
                witnessCarryCycles: {
                    pending: { ...state.witnessCarryCycles.pending, [action.payload.key]: false },
                    error: { ...state.witnessCarryCycles.error, [action.payload.key]: action.payload.error },
                },
            };
        case DELETE_WITNESS_CARRY_CYCLE_REQUEST:
            return {
                ...state,
                witnessCarryCycles: {
                    pending: { ...state.witnessCarryCycles.pending, [action.payload.key]: true },
                    error: { ...state.witnessCarryCycles.error, [action.payload.key]: null },
                },
            };
        case DELETE_WITNESS_CARRY_CYCLE_SUCCESS:
            return {
                ...state,
                witnessCarryCycles: {
                    pending: { ...state.witnessCarryCycles.pending, [action.payload.key]: false },
                    error: { ...state.witnessCarryCycles.error, [action.payload.key]: null },
                },
            };
        case DELETE_WITNESS_CARRY_CYCLE_FAILURE:
            return {
                ...state,
                witnessCarryCycles: {
                    pending: { ...state.witnessCarryCycles.pending, [action.payload.key]: false },
                    error: { ...state.witnessCarryCycles.error, [action.payload.key]: action.payload.error },
                },
            };

        case LAST_SEVEN_RDELIVERY_REQUEST:
            return {
                ...state,
                lastSevenDeliveries: {
                    list: [],
                    status: 'loading',
                    error: null,
                }
            };

        case LAST_SEVEN_RDELIVERY_SUCCESS:
            return {
                ...state,
                lastSevenDeliveries: {
                    list: action.payload,
                    status: 'succeeded',
                    error: null,
                }
            };

        case LAST_SEVEN_RDELIVERY_FAILURE:
            return {
                ...state,
                lastSevenDeliveries: {
                    list: [],
                    status: 'failed',
                    error: action.payload,
                }
            };

        default:
            return state;
    }
};
export const selectLastSevenDeliveries = (state) => state.investigateRX?.lastSevenDeliveries?.list;
export const selectLastSevenDeliveriesStatus = (state) => state.investigateRX?.lastSevenDeliveries?.status;
export const selectLastSevenDeliveriesError = (state) => state.investigateRX?.lastSevenDeliveries?.error;

export const selectWitnessCarryPending = (state) => state.investigateRX?.witnessCarryCycles?.pending || {};
export const selectWitnessCarryErrors = (state) => state.investigateRX?.witnessCarryCycles?.error || {};

export default investigateRxListReducer;
